import React, { useState, useMemo } from 'react';
import { Search, ChefHat, Clock, Users, X, Plus, Sparkles, Moon, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';

// Move the entire RecipeDatabase array definition here 
 // Comprehensive recipe database with detailed measurements
  const recipeDatabase = [
    {
      id: 1,
      name: "Classic Scrambled Eggs",
      ingredients: [
        { name: "eggs", amount: "4 large", searchTerm: "eggs" },
        { name: "butter", amount: "2 tablespoons", searchTerm: "butter" },
        { name: "milk", amount: "2 tablespoons", searchTerm: "milk" },
        { name: "salt", amount: "1/4 teaspoon", searchTerm: "salt" },
        { name: "pepper", amount: "1/8 teaspoon", searchTerm: "pepper" }
      ],
      instructions: [
        "Crack 4 eggs into a bowl and whisk with 2 tablespoons milk, salt, and pepper",
        "Heat 2 tablespoons butter in a non-stick pan over medium-low heat",
        "Pour in eggs and let sit for 30 seconds",
        "Gently stir with a spatula, pushing eggs from edges to center",
        "Continue cooking and stirring until eggs are set but still creamy",
        "Remove from heat and serve immediately"
      ],
      cookTime: 10,
      servings: 2,
      difficulty: "Easy",
      category: "Breakfast"
    },
    {
      id: 2,
      name: "Pasta Aglio e Olio",
      ingredients: [
        { name: "pasta", amount: "1 pound spaghetti", searchTerm: "pasta" },
        { name: "garlic", amount: "6 cloves, thinly sliced", searchTerm: "garlic" },
        { name: "olive oil", amount: "1/2 cup extra virgin", searchTerm: "olive oil" },
        { name: "red pepper flakes", amount: "1/2 teaspoon", searchTerm: "red pepper flakes" },
        { name: "parsley", amount: "1/2 cup fresh, chopped", searchTerm: "parsley" },
        { name: "parmesan", amount: "1/2 cup grated", searchTerm: "parmesan" }
      ],
      instructions: [
        "Cook 1 pound pasta in salted boiling water until al dente",
        "Meanwhile, slice 6 garlic cloves thinly and heat 1/2 cup olive oil in a large pan",
        "Add garlic to oil and cook until golden and fragrant",
        "Add 1/2 teaspoon red pepper flakes and cook for 30 seconds",
        "Drain pasta, reserving 1 cup pasta water",
        "Add pasta to the garlic oil with a splash of pasta water",
        "Toss vigorously, adding more pasta water if needed",
        "Remove from heat, add 1/2 cup chopped parsley and 1/2 cup grated parmesan",
        "Serve immediately with extra parmesan"
      ],
      cookTime: 20,
      servings: 4,
      difficulty: "Easy",
      category: "Dinner"
    },
    {
      id: 3,
      name: "Chicken Stir Fry",
      ingredients: [
        { name: "chicken", amount: "1 pound boneless breast", searchTerm: "chicken" },
        { name: "soy sauce", amount: "3 tablespoons", searchTerm: "soy sauce" },
        { name: "garlic", amount: "3 cloves, minced", searchTerm: "garlic" },
        { name: "ginger", amount: "1 tablespoon fresh, minced", searchTerm: "ginger" },
        { name: "vegetables", amount: "3 cups mixed (bell peppers, broccoli)", searchTerm: "vegetables" },
        { name: "oil", amount: "2 tablespoons vegetable oil", searchTerm: "oil" },
        { name: "rice", amount: "2 cups cooked", searchTerm: "rice" }
      ],
      instructions: [
        "Cut 1 pound chicken into bite-sized pieces and season with salt",
        "Heat 2 tablespoons oil in a wok or large skillet over high heat",
        "Cook chicken until golden brown, then remove and set aside",
        "Add 3 minced garlic cloves and 1 tablespoon minced ginger, stir for 30 seconds",
        "Add 3 cups mixed vegetables and stir-fry for 3-4 minutes until crisp-tender",
        "Return chicken to pan and add 3 tablespoons soy sauce",
        "Toss everything together for 2 minutes",
        "Serve hot over 2 cups cooked rice"
      ],
      cookTime: 25,
      servings: 4,
      difficulty: "Medium",
      category: "Dinner"
    },
    {
      id: 4,
      name: "Avocado Toast",
      ingredients: [
        { name: "bread", amount: "4 slices whole grain", searchTerm: "bread" },
        { name: "avocado", amount: "2 large ripe avocados", searchTerm: "avocado" },
        { name: "lime", amount: "1 lime, juiced", searchTerm: "lime" },
        { name: "salt", amount: "1/2 teaspoon sea salt", searchTerm: "salt" },
        { name: "pepper", amount: "1/4 teaspoon black pepper", searchTerm: "pepper" },
        { name: "tomato", amount: "1 large tomato, sliced", searchTerm: "tomato" }
      ],
      instructions: [
        "Toast 4 slices bread until golden brown",
        "Mash 2 avocados in a bowl with juice of 1 lime, 1/2 teaspoon salt, and 1/4 teaspoon pepper",
        "Spread avocado mixture generously on toast",
        "Top with sliced tomato if available",
        "Season with additional salt and pepper to taste",
        "Serve immediately while toast is still warm"
      ],
      cookTime: 5,
      servings: 2,
      difficulty: "Easy",
      category: "Breakfast"
    },
    {
      id: 5,
      name: "Beef Tacos",
      ingredients: [
        { name: "ground beef", amount: "1 pound 85% lean", searchTerm: "ground beef" },
        { name: "onion", amount: "1 medium, diced", searchTerm: "onion" },
        { name: "garlic", amount: "2 cloves, minced", searchTerm: "garlic" },
        { name: "cumin", amount: "1 tablespoon ground", searchTerm: "cumin" },
        { name: "chili powder", amount: "1 tablespoon", searchTerm: "chili powder" },
        { name: "tomato", amount: "1 can (14 oz) diced", searchTerm: "tomato" },
        { name: "cheese", amount: "2 cups shredded cheddar", searchTerm: "cheese" },
        { name: "tortillas", amount: "12 small corn tortillas", searchTerm: "tortillas" },
        { name: "lettuce", amount: "2 cups shredded iceberg", searchTerm: "lettuce" }
      ],
      instructions: [
        "Brown 1 pound ground beef in a large skillet over medium-high heat",
        "Add 1 diced onion and 2 minced garlic cloves, cook until softened",
        "Season with 1 tablespoon each of cumin and chili powder, salt, and pepper",
        "Add 1 can diced tomatoes and simmer for 10 minutes",
        "Warm 12 tortillas in a dry skillet or microwave",
        "Fill tortillas with beef mixture",
        "Top with 2 cups shredded cheese and 2 cups lettuce",
        "Serve with lime wedges and hot sauce"
      ],
      cookTime: 30,
      servings: 6,
      difficulty: "Medium",
      category: "Dinner"
    },
    {
      id: 6,
      name: "Caesar Salad",
      ingredients: [
        { name: "lettuce", amount: "2 heads romaine, chopped", searchTerm: "lettuce" },
        { name: "parmesan", amount: "1 cup grated fresh", searchTerm: "parmesan" },
        { name: "bread", amount: "4 slices day-old bread", searchTerm: "bread" },
        { name: "garlic", amount: "3 cloves, minced", searchTerm: "garlic" },
        { name: "lemon", amount: "2 lemons, juiced", searchTerm: "lemon" },
        { name: "olive oil", amount: "1/2 cup extra virgin", searchTerm: "olive oil" },
        { name: "anchovies", amount: "4 fillets, mashed", searchTerm: "anchovies" }
      ],
      instructions: [
        "Cut 4 slices bread into cubes and toss with 2 tablespoons olive oil and 1 minced garlic clove",
        "Bake croutons at 375°F for 10-12 minutes until golden",
        "Wash and chop 2 heads romaine lettuce into bite-sized pieces",
        "Make dressing by whisking juice of 2 lemons, 2 minced garlic cloves, 4 mashed anchovies, and remaining olive oil",
        "Toss lettuce with dressing until well coated",
        "Top with croutons and 1 cup grated parmesan cheese",
        "Serve immediately"
      ],
      cookTime: 20,
      servings: 4,
      difficulty: "Medium",
      category: "Salad"
    },
    {
      id: 7,
      name: "Oatmeal Pancakes",
      ingredients: [
        { name: "flour", amount: "2 cups all-purpose", searchTerm: "flour" },
        { name: "organic oats", amount: "1 cup organic oats", searchTerm: "oats" },
        { name: "milk", amount: "1 1/2 cups whole milk", searchTerm: "milk" },
        { name: "eggs", amount: "2 large eggs", searchTerm: "eggs" },
        { name: "sugar", amount: "2 tablespoons", searchTerm: "sugar" },
        { name: "baking powder", amount: "2 teaspoons", searchTerm: "baking powder" },
        { name: "baking soda", amount: "1 tsp", searchTerm: "baking soda" },
        { name: "butter", amount: "4 tablespoons melted", searchTerm: "butter" },
        { name: "salt", amount: "1/2 teaspoon", searchTerm: "salt" },
        { name: "nuts", amount: "1/2 teaspoon", searchTerm: "nuts" },
        { name: "chocolate chips", amount: "1/4 cup", searchTerm: "chocolate chips" },
        { name: "berries", amount: "1/4 cup", searchTerm: "berries" }
      ],
      instructions: [
        "Mix 2 cups flour, 1 cup organic oats, 2 tablespoons sugar, 2 teaspoons baking powder, 1 tsp baking soda, and 1/2 teaspoon salt in a large bowl",
        "Whisk 1 1/2 cups milk, 2 eggs, and 4 tablespoons melted butter in another bowl",
        "Pour wet ingredients into dry ingredients and stir until just combined",
        "Don't overmix - lumps are okay",
        "Add 1-2 Tbsp butter to grease griddle or large pan at medium heat, wait until pan is warm",
        "Pour 1/4 cup batter per pancake onto hot griddle",
        "Add nuts, berries, chocolate chips, have fun with it!",
        "Cook until bubbles form on surface, then flip",
        "Cook until golden brown on both sides",
        "Serve hot, with syrup and butter"
      ],
      cookTime: 20,
      servings: 4,
      difficulty: "Easy",
      category: "Breakfast"
    },
    {
      id: 8,
      name: "Vegetable Soup",
      ingredients: [
        { name: "onion", amount: "1 large, diced", searchTerm: "onion" },
        { name: "carrots", amount: "3 medium, sliced", searchTerm: "carrots" },
        { name: "celery", amount: "3 stalks, chopped", searchTerm: "celery" },
        { name: "tomato", amount: "2 cans (14 oz each) diced", searchTerm: "tomato" },
        { name: "vegetable broth", amount: "6 cups", searchTerm: "vegetable broth" },
        { name: "herbs", amount: "2 tsp dried thyme, 2 bay leaves", searchTerm: "herbs" },
        { name: "garlic", amount: "4 cloves, minced", searchTerm: "garlic" },
        { name: "olive oil", amount: "2 tablespoons", searchTerm: "olive oil" }
      ],
      instructions: [
        "Heat 2 tablespoons olive oil in a large pot over medium heat",
        "Add 1 diced onion, 3 sliced carrots, and 3 chopped celery stalks, cook until softened",
        "Add 4 minced garlic cloves and cook for 1 minute",
        "Add 2 cans diced tomatoes and cook for 5 minutes",
        "Pour in 6 cups vegetable broth and bring to a boil",
        "Add 2 teaspoons thyme and 2 bay leaves, season with salt and pepper",
        "Simmer for 20-25 minutes until vegetables are tender",
        "Remove bay leaves, taste and adjust seasoning before serving"
      ],
      cookTime: 35,
      servings: 6,
      difficulty: "Easy",
      category: "Soup"
    },

  // === 9/24/25  Addded---- 102 Recipes ===

  {
    id: 9,
    name: "Avocado Toast with Egg",
    ingredients: [
      { name: "bread", amount: "2 slices", searchTerm: "bread" },
      { name: "avocado", amount: "1", searchTerm: "avocado" },
      { name: "eggs",amount: "2", searchTerm: "eggs" },
      { name: "olive oild",amount: "1 tbsp", searchTerm: "olive oil" },
      { name: "salt",amount: "to taste", searchTerm: "salt" },
      { name: "pepper",amount: "to taste", searchTerm: "pepper" }
    ],
    instructions: [
      "Toast the bread slices.",
      "Mash avocado with salt and pepper.",
      "Fry eggs in olive oil to your preference.",
      "Spread avocado on toast and top with fried eggs."
    ],
    cookTime: 10,
    servings: 2,
    difficulty: "Easy",
    category: "Breakfast"
  },
  {
    id: 10,
    name: "Chicken Caesar Salad",
    ingredients: [
      {name: "lettuce", amount: "2 cups", searchTerm: "romaine lettuce" },
      { name: "grilled chicken", amount: "1 cup", searchTerm: "grilled chicken" },
      { name: "cheese", amount: "1/2 cup", searchTerm: "parmesan cheese" },
      { name: "croutons", amount: "1/2 cup", searchTerm: "croutons" },
      {name: "Caesar dressing", amount: "1/4 cup", searchTerm: "Caesar dressing" }
    ],
    instructions: [
      "Chop romaine and place in a bowl.",
      "Top with grilled chicken, parmesan, and croutons.",
      "Drizzle with Caesar dressing and toss lightly."
    ],
    cookTime: 15,
    servings: 2,
    difficulty: "Easy",
    category: "Salad"
  },
   {
    id: 11,
    name: "Beef Stir Fry",
    ingredients: [
      { name: "beef strips", amount: "1 lb", searchTerm: "beef strips" },
      { name: "mixed vegetables", amount: "2 cups", searchTerm: "mixed vegetables" },
      { name: "soy sauce", amount: "3 tbsp", searchTerm: "soy sauce" },
      { name: "ginger", amount: "1 tbsp", searchTerm: "ginger" },
      { name: "garlic", amount: "1 tbsp", searchTerm: "garlic" },
      { name: "vegetable oil", amount: "2 tbsp", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "Heat oil in a pan over medium heat.",
      "Stir fry beef until browned.",
      "Add vegetables, garlic, and ginger; cook 3-4 mins.",
      "Stir in soy sauce and cook another 2 mins."
    ],
    cookTime: 20,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 12,
    name: "Banana Smoothie",
    ingredients: [
      { name: "bananas", amount: "2", searchTerm: "bananas" },
      { name: "milk", amount: "1 cup", searchTerm: "milk" },
      { name: "yogurt", amount: "1/2 cup", searchTerm: "yogurt" },
      { name: "honey", amount: "1 tbsp", searchTerm: "honey" },
      { name: "ice cubes", amount: "1/2 cup", searchTerm: "ice cubes" }
    ],
    instructions: [
      "Place all ingredients in a blender.",
      "Blend until smooth.",
      "Pour into glasses and serve immediately."
    ],
    cookTime: 5,
    servings: 2,
    difficulty: "Easy",
    category: "Smoothie"
  },
  {
    id: 13,
    name: "Tomato Basil Soup",
    ingredients: [
      { name: "tomatoes", amount: "4 cups", searchTerm: "tomatoes" },
      { name: "onion", amount: "1", searchTerm: "onion" },
      { name: "garlic", amount: "2 cloves", searchTerm: "garlic" },
      { name: "vegetable broth", amount: "2 cups", searchTerm: "vegetable broth" },
      { name: "fresh basil", amount: "1/4 cup", searchTerm: "fresh basil" },
      { name: "olive oil", amount: "1 tbsp", searchTerm: "olive oil" }
    ],
    instructions: [
      "Sauté onion and garlic in olive oil until soft.",
      "Add tomatoes and cook for 5 minutes.",
      "Pour in broth and simmer 20 minutes.",
      "Blend until smooth and stir in fresh basil."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Easy",
    category: "Soup"
  },
  {
    id: 14,
    name: "Turkey Sandwich",
    ingredients: [
      { name: "bread", amount: "2 slices", searchTerm: "bread" },
      { name: "turkey breast", amount: "4 slices", searchTerm: "turkey breast" },
      { name: "cheddar cheese", amount: "2 slices", searchTerm: "cheddar cheese" },
      { name: "lettuce", amount: "2 leaves", searchTerm: "lettuce" },
      { name: "tomato", amount: "2 slices", searchTerm: "tomato" },
      { name: "mayonnaise", amount: "1 tbsp", searchTerm: "mayonnaise" }
    ],
    instructions: [
      "Spread mayonnaise on bread slices.",
      "Layer turkey, cheese, lettuce, and tomato.",
      "Top with the second slice of bread and serve."
    ],
    cookTime: 5,
    servings: 1,
    difficulty: "Easy",
    category: "Sandwich"
  },
  {
    id: 15,
    name: "Veggie Omelette",
    ingredients: [
      { name: "eggs", amount: "3", searchTerm: "eggs" },
      { name: "bell peppers", amount: "1/4 cup", searchTerm: "bell peppers" },
      { name: "mushrooms", amount: "1/4 cup", searchTerm: "mushrooms" },
      { name: "milk", amount: "2 tbsp", searchTerm: "milk" },
      { name: "butter", amount: "1 tbsp", searchTerm: "butter" },
      { name: "salt", amount: "to taste", searchTerm: "salt" }
    ],
    instructions: [
      "Whisk eggs with milk and salt.",
      "Melt butter in a pan and sauté veggies.",
      "Pour in eggs and cook until set.",
      "Fold omelette and serve hot."
    ],
    cookTime: 10,
    servings: 1,
    difficulty: "Easy",
    category: "Breakfast"
  },
  {
    id: 16,
    name: "Shrimp Tacos",
    ingredients: [
      { name: "shrimp", amount: "1 lb", searchTerm: "shrimp" },
      { name: "tortillas", amount: "6", searchTerm: "tortillas" },
      { name: "cabbage slaw", amount: "1 cup", searchTerm: "cabbage slaw" },
      { name: "sour cream", amount: "1/4 cup", searchTerm: "sour cream" },
      { name: "lime juice", amount: "1 tbsp", searchTerm: "lime juice" },
      { name: "olive oil", amount: "1 tbsp", searchTerm: "olive oil" }
    ],
    instructions: [
      "Cook shrimp in olive oil until pink.",
      "Warm tortillas in a pan.",
      "Mix sour cream with lime juice.",
      "Assemble tacos with shrimp, slaw, and sauce."
    ],
    cookTime: 20,
    servings: 3,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 17,
    name: "Greek Yogurt Parfait",
    ingredients: [
      { name: "Greek yogurt", amount: "1 cup", searchTerm: "Greek yogurt" },
      { name: "granola", amount: "1/2 cup", searchTerm: "granola" },
      { name: "berries", amount: "1/2 cup", searchTerm: "berries" },
      { name: "honey", amount: "1 tbsp", searchTerm: "honey" }
    ],
    instructions: [
      "Layer yogurt, granola, and berries in a glass.",
      "Drizzle honey on top.",
      "Serve chilled."
    ],
    cookTime: 5,
    servings: 1,
    difficulty: "Easy",
    category: "Breakfast"
  },
  {
    id: 18,
    name: "Pasta Primavera",
    ingredients: [
      { name: "pasta", amount: "8 oz", searchTerm: "pasta" },
      { name: "mixed vegetables", amount: "2 cups", searchTerm: "mixed vegetables" },
      { name: "olive oil", amount: "2 tbsp", searchTerm: "olive oil" },
      { name: "garlic", amount: "1 clove", searchTerm: "garlic" },
      { name: "parmesan cheese", amount: "1/4 cup", searchTerm: "parmesan cheese" }
    ],
    instructions: [
      "Cook pasta according to package instructions.",
      "Sauté garlic and vegetables in olive oil.",
      "Mix cooked pasta with vegetables.",
      "Top with parmesan cheese."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Easy",
    category: "Lunch"
  },
  {
    id: 19,
    name: "Classic BLT Sandwich",
    ingredients: [
      { name: "bread", amount: "2 slices", searchTerm: "bread" },
      { name: "bacon", amount: "3 slices", searchTerm: "bacon" },
      { name: "lettuce", amount: "2 leaves", searchTerm: "lettuce" },
      { name: "tomato", amount: "2 slices", searchTerm: "tomato" },
      { name: "mayonnaise", amount: "1 tbsp", searchTerm: "mayonnaise" }
    ],
    instructions: [
      "Cook bacon until crispy.",
      "Spread mayonnaise on bread.",
      "Layer bacon, lettuce, and tomato.",
      "Top with second bread slice."
    ],
    cookTime: 10,
    servings: 1,
    difficulty: "Easy",
    category: "Sandwich"
  },
  {
    id: 20,
    name: "Minestrone Soup",
    ingredients: [
      { name: "vegetable broth", amount: "2 cups", searchTerm: "vegetable broth" },
      { name: "diced tomatoes", amount: "1 cup", searchTerm: "diced tomatoes" },
      { name: "carrots", amount: "1/2 cup", searchTerm: "carrots" },
      { name: "celery", amount: "1/2 cup", searchTerm: "celery" },
      { name: "pasta", amount: "1/2 cup", searchTerm: "pasta" },
      { name: "beans", amount: "1/4 cup", searchTerm: "beans" }
    ],
    instructions: [
      "Sauté carrots and celery in olive oil.",
      "Add broth, tomatoes, and beans.",
      "Simmer for 20 minutes.",
      "Add pasta and cook until tender."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Easy",
    category: "Soup"
  },
  {
    id: 21,
    name: "Grilled Salmon with Lemon",
    ingredients: [
      { name: "salmon", amount: "2 fillets", searchTerm: "salmon" },
      { name: "olive oil", amount: "1 tbsp", searchTerm: "olive oil" },
      { name: "lemon juice", amount: "1 tbsp", searchTerm: "lemon juice" },
      { name: "salt", amount: "to taste", searchTerm: "salt" },
      { name: "pepper", amount: "to taste", searchTerm: "pepper" }
    ],
    instructions: [
      "Brush salmon with olive oil, salt, and pepper.",
      "Grill on medium-high heat 4–5 minutes per side.",
      "Squeeze fresh lemon juice before serving."
    ],
    cookTime: 15,
    servings: 2,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 22,
    name: "Chocolate Chip Cookies",
    ingredients: [
      { name: "butter", amount: "1 cup", searchTerm: "butter" },
      { name: "sugar", amount: "1 cup", searchTerm: "sugar" },
      { name: "eggs", amount: "2", searchTerm: "eggs" },
      { name: "flour", amount: "2 1/4 cups", searchTerm: "flour" },
      { name: "baking soda", amount: "1 tsp", searchTerm: "baking soda" },
      { name: "chocolate chips", amount: "1 cup", searchTerm: "chocolate chips" }
    ],
    instructions: [
      "Preheat oven to 350°F (175°C).",
      "Cream butter and sugar together.",
      "Add eggs, then stir in flour and baking soda.",
      "Fold in chocolate chips.",
      "Scoop dough onto baking sheet and bake 10–12 mins."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Medium",
    category: "Dessert"
  },
  {
    id: 23,
    name: "Caprese Salad",
    ingredients: [
      { name: "tomatoes", amount: "2", searchTerm: "tomatoes" },
      { name: "mozzarella", amount: "1 ball", searchTerm: "mozzarella" },
      { name: "fresh basil", amount: "1/4 cup", searchTerm: "fresh basil" },
      { name: "olive oil", amount: "2 tbsp", searchTerm: "olive oil" },
      { name: "balsamic vinegar", amount: "1 tbsp", searchTerm: "balsamic vinegar" }
    ],
    instructions: [
      "Slice tomatoes and mozzarella.",
      "Layer with basil leaves on a plate.",
      "Drizzle with olive oil and balsamic vinegar."
    ],
    cookTime: 10,
    servings: 2,
    difficulty: "Easy",
    category: "Salad"
  },
  {
    id: 24,
    name: "Berry Smoothie",
    ingredients: [
      { name: "mixed berries", amount: "1 cup", searchTerm: "mixed berries" },
      { name: "milk", amount: "1 cup", searchTerm: "milk" },
      { name: "yogurt", amount: "1/2 cup", searchTerm: "yogurt" },
      { name: "honey", amount: "1 tbsp", searchTerm: "honey" },
      { name: "ice", amount: "1/2 cup", searchTerm: "ice" }
    ],
    instructions: [
      "Add all ingredients to a blender.",
      "Blend until smooth.",
      "Serve immediately."
    ],
    cookTime: 5,
    servings: 2,
    difficulty: "Easy",
    category: "Smoothie"
  },
  {
    id: 25,
    name: "Vegetable Quesadilla",
    ingredients: [
      { name: "tortillas", amount: "2", searchTerm: "tortillas" },
      { name: "bell peppers", amount: "1/2 cup", searchTerm: "bell peppers" },
      { name: "onions", amount: "1/2 cup", searchTerm: "onions" },
      { name: "cheese", amount: "1/2 cup", searchTerm: "cheese" },
      { name: "olive oil", amount: "1 tbsp", searchTerm: "olive oil" }
    ],
    instructions: [
      "Sauté peppers and onions in olive oil.",
      "Place vegetables and cheese between tortillas.",
      "Cook on skillet until golden and cheese melts.",
      "Cut into wedges and serve."
    ],
    cookTime: 15,
    servings: 2,
    difficulty: "Easy",
    category: "Snack"
  },
  {
    id: 26,
    name: "Chicken Fried Rice",
    ingredients: [
      { name: "cooked rice", amount: "2 cups", searchTerm: "cooked rice" },
      { name: "chicken", amount: "1 cup", searchTerm: "chicken" },
      { name: "peas", amount: "1/2 cup", searchTerm: "peas" },
      { name: "carrots", amount: "1/2 cup", searchTerm: "carrots" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "eggs", amount: "2", searchTerm: "eggs" }
    ],
    instructions: [
      "Scramble eggs in a large skillet and set aside.",
      "Sauté chicken, peas, and carrots until fully cooked.",
      "Add rice and soy sauce; stir fry 5 mins.",
      "Mix eggs back in and serve."
    ],
    cookTime: 20,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 27,
    name: "Fruit Salad",
    ingredients: [
      { name: "strawberries", amount: "1 cup", searchTerm: "strawberries" },
      { name: "pineapple", amount: "1 cup", searchTerm: "pineapple" },
      { name: "grapes", amount: "1 cup", searchTerm: "grapes" },
      { name: "melon", amount: "1 cup", searchTerm: "melon" },
      { name: "honey", amount: "1 tbsp", searchTerm: "honey" },
      { name: "lime juice", amount: "1 tbsp", searchTerm: "lime juice" }
    ],
    instructions: [
      "Chop all fruit into bite-sized pieces.",
      "Mix honey and lime juice in a bowl.",
      "Toss fruit with dressing and chill before serving."
    ],
    cookTime: 10,
    servings: 4,
    difficulty: "Easy",
    category: "Dessert"
  },
  {
    id: 28,
    name: "Lentil Soup",
    ingredients: [
      { name: "lentils", amount: "1 cup", searchTerm: "lentils" },
      { name: "onion", amount: "1", searchTerm: "onion" },
      { name: "carrots", amount: "2", searchTerm: "carrots" },
      { name: "garlic", amount: "2 cloves", searchTerm: "garlic" },
      { name: "vegetable broth", amount: "4 cups", searchTerm: "vegetable broth" },
      { name: "olive oil", amount: "1 tbsp", searchTerm: "olive oil" }
    ],
    instructions: [
      "Sauté onion, carrots, and garlic in olive oil.",
      "Add lentils and broth.",
      "Simmer for 30–35 minutes until lentils are tender.",
      "Serve warm."
    ],
    cookTime: 40,
    servings: 4,
    difficulty: "Easy",
    category: "Soup"
  },
  {
    id: 29,
    name: "Shredded Chicken Tacos",
    ingredients: [
      { name: "chicken breast", amount: "2 cups", searchTerm: "chicken breast" },
      { name: "tortillas", amount: "6", searchTerm: "tortillas" },
      { name: "onion", amount: "1/2 cup", searchTerm: "onion" },
      { name: "cilantro", amount: "1/2 cup", searchTerm: "cilantro" },
      { name: "salsa", amount: "1/2 cup", searchTerm: "salsa" }
    ],
    instructions: [
      "Cook chicken until fully done. Use two forks and shred chicken.",
      "Warm tortillas in a skillet.",
      "Fill with chicken, onion, cilantro, and salsa.",
      "Serve with lime wedges."
    ],
    cookTime: 20,
    servings: 3,
    difficulty: "Easy",
    category: "Mexican"
  },
  {
    id: 30,
    name: "Beef Enchiladas",
    ingredients: [
      { name: "ground beef", amount: "1 lb", searchTerm: "ground beef" },
      { name: "enchilada sauce", amount: "1 cup", searchTerm: "enchilada sauce" },
      { name: "tortillas", amount: "6", searchTerm: "tortillas" },
      { name: "cheese", amount: "1 cup", searchTerm: "cheese" },
      { name: "onions", amount: "1/2 cup", searchTerm: "onions" }
    ],
    instructions: [
      "Cook beef with onions and seasonings.",
      "Fill tortillas with beef and roll.",
      "Place in baking dish, cover with sauce and cheese.",
      "Bake at 375°F for 20 minutes."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Medium",
    category: "Mexican"
  },
  {
    id: 31,
    name: "Guacamole",
    ingredients: [
      { name: "avocados", amount: "2", searchTerm: "avocados" },
      { name: "onion", amount: "1/4 cup", searchTerm: "onion" },
      { name: "lime", amount: "1", searchTerm: "lime" },
      { name: "tomato", amount: "1/4 cup", searchTerm: "tomato" },
      { name: "cilantro", amount: "2 tbsp", searchTerm: "cilantro" }
    ],
    instructions: [
      "Mash avocados in a bowl.",
      "Stir in onion, tomato, lime juice, and cilantro.",
      "Season with salt and pepper."
    ],
    cookTime: 10,
    servings: 4,
    difficulty: "Easy",
    category: "Mexican"
  },
  {
    id: 32,
    name: "Mac and Cheese",
    ingredients: [
      { name: "elbow macaroni", amount: "2 cups", searchTerm: "elbow macaroni" },
      { name: "cheddar cheese", amount: "2 cups", searchTerm: "cheddar cheese" },
      { name: "butter", amount: "2 tbsp", searchTerm: "butter" },
      { name: "flour", amount: "2 tbsp", searchTerm: "flour" },
      { name: "milk", amount: "2 cups", searchTerm: "milk" }
    ],
    instructions: [
      "Cook macaroni according to package instructions.",
      "Make cheese sauce by whisking butter, flour, and milk.",
      "Add cheese until melted.",
      "Mix with macaroni and serve."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Easy",
    category: "American"
  },
  {
    id: 33,
    name: "BBQ Ribs",
    ingredients: [
      { name: "pork ribs", amount: "2 lbs", searchTerm: "pork ribs" },
      { name: "BBQ sauce", amount: "1 cup", searchTerm: "BBQ sauce" },
      { name: "brown sugar", amount: "2 tbsp", searchTerm: "brown sugar" },
      { name: "paprika", amount: "1 tbsp", searchTerm: "paprika" },
      { name: "garlic powder", amount: "1 tsp", searchTerm: "garlic powder" }
    ],
    instructions: [
      "Season ribs with spices and wrap in foil.",
      "Bake at 300°F for 2 hours.",
      "Brush with BBQ sauce and grill for 10 mins."
    ],
    cookTime: 90,
    servings: 4,
    difficulty: "Medium",
    category: "American"
  },
  {
    id: 34,
    name: "Clam Chowder",
    ingredients: [
      { name: "clams", amount: "2 cups", searchTerm: "clams" },
      { name: "potatoes", amount: "2", searchTerm: "potatoes" },
      { name: "celery", amount: "1 cup", searchTerm: "celery" },
      { name: "onion", amount: "1 cup", searchTerm: "onion" },
      { name: "milk", amount: "2 cups", searchTerm: "milk" }
    ],
    instructions: [
      "Cook onion and celery in butter.",
      "Add clams, potatoes, and broth.",
      "Simmer until potatoes are soft.",
      "Stir in milk and season to taste."
    ],
    cookTime: 40,
    servings: 4,
    difficulty: "Medium",
    category: "American"
  },
  {
    id: 35,
    name: "Chicken & Cheese Fajitas",
    ingredients: [
      { name: "chicken", amount: "1 lb", searchTerm: "chicken" },
      { name: "bell peppers", amount: "1 cup", searchTerm: "bell peppers" },
      { name: "onions", amount: "1 cup", searchTerm: "onions" },
      { name: "tortillas", amount: "6", searchTerm: "tortillas" },
      { name: "fajita seasoning", amount: "2 tbsp", searchTerm: "fajita seasoning" },
      { name: "cheese", amount: "1/4 lb", searchTerm: "cheese, shredded cheese" },
    ],
    instructions: [
      "Fully cook chicken with fajita seasoning.",
      "Add sliced peppers and onions.",
      "Serve in warm tortillas with toppings."
    ],
    cookTime: 20,
    servings: 3,
    difficulty: "Easy",
    category: "Mexican"
  },
  {
    id: 36,
    name: "Apple Pie",
    ingredients: [
      { amount: "2", searchTerm: "pie crusts" },
      { amount: "6", searchTerm: "apples" },
      { amount: "1/2 cup", searchTerm: "sugar" },
      { amount: "1 tsp", searchTerm: "cinnamon" },
      { amount: "1 tbsp", searchTerm: "flour" }
    ],
    instructions: [
      "Peel and slice apples.",
      "Mix with sugar, flour, and cinnamon.",
      "Place filling in crust and cover with top crust.",
      "Bake at 375°F for 50 mins."
    ],
    cookTime: 60,
    servings: 8,
    difficulty: "Medium",
    category: "American"
  },
  {
    id: 37,
    name: "Buffalo Wings",
    ingredients: [
      { amount: "2 lbs", searchTerm: "chicken wings" },
      { amount: "1/2 cup", searchTerm: "hot sauce" },
      { amount: "2 tbsp", searchTerm: "butter" },
      { amount: "1 tsp", searchTerm: "garlic powder" },
      { amount: "to taste", searchTerm: "salt" }
    ],
    instructions: [
      "Bake wings at 400°F for 40 minutes.",
      "Mix hot sauce with melted butter.",
      "Toss wings in sauce before serving."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium",
    category: "American"
  },
  {
    id: 38,
    name: "Nachos",
    ingredients: [
      { amount: "1 bag", searchTerm: "tortilla chips" },
      { amount: "1 cup", searchTerm: "cheese" },
      { amount: "1/2 cup", searchTerm: "jalapeños" },
      { amount: "1/2 cup", searchTerm: "salsa" },
      { amount: "1/2 cup", searchTerm: "sour cream" }
    ],
    instructions: [
      "Spread chips on baking tray.",
      "Top with cheese and jalapeños.",
      "Bake at 350°F for 10 mins.",
      "Add salsa and sour cream before serving."
    ],
    cookTime: 15,
    servings: 4,
    difficulty: "Easy",
    category: "Mexican"
  },
  {
    id: 39,
    name: "Cornbread",
    ingredients: [
      { amount: "1 cup", searchTerm: "cornmeal" },
      { amount: "1 cup", searchTerm: "flour" },
      { amount: "1/4 cup", searchTerm: "sugar" },
      { amount: "1", searchTerm: "egg" },
      { amount: "1 cup", searchTerm: "milk" }
    ],
    instructions: [
      "Mix dry ingredients in a bowl.",
      "Add egg and milk; stir until combined.",
      "Pour into greased pan and bake at 375°F for 25 mins."
    ],
    cookTime: 30,
    servings: 6,
    difficulty: "Easy",
    category: "American"
  },
  {
    id: 40,
    name: "Shrimp Stir-Fry",
    ingredients: [
      { amount: "1 lb", searchTerm: "shrimp" },
      { amount: "2 cups", searchTerm: "vegetables" },
      { amount: "2 tbsp", searchTerm: "soy sauce" },
      { amount: "1 tbsp", searchTerm: "ginger" },
      { amount: "2 tbsp", searchTerm: "oil" }
    ],
    instructions: [
      "Heat oil in a wok.",
      "Cook shrimp until pink, remove and set aside.",
      "Stir-fry vegetables with soy sauce and ginger.",
      "Return shrimp and toss before serving."
    ],
    cookTime: 15,
    servings: 3,
    difficulty: "Easy",
    category: "Asian"
  },
  {
    id: 41,
    name: "Peruvian Ceviche (Ceviche Clásico)",
    ingredients: [
      { amount: "1 lb", searchTerm: "white fish" },
      { amount: "10-12, juiced", searchTerm: "limes" },
      { amount: "1, thinly sliced", searchTerm: "red onion" },
      { amount: "1, finely minced", searchTerm: "chili pepper" },
      { amount: "1/4 cup, chopped", searchTerm: "cilantro" },
      { amount: "1, boiled and sliced", searchTerm: "sweet potato" },
      { amount: "1 cob, boiled", searchTerm: "corn" },
      { amount: "to taste", searchTerm: "salt" }
    ],
    instructions: [
      "Cut the fish into 1-inch cubes and place in a glass bowl.",
      "Add the lime juice, chili, and salt, mixing gently. Let marinate for 10-15 minutes until the fish turns opaque.",
      "Stir in the red onion and cilantro.",
      "Serve immediately with slices of boiled sweet potato and corn."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Medium",
    category: "Lunch"
  },
  {
    id: 42,
    name: "Japanese Miso Soup (Miso Shiru)",
    ingredients: [
      { amount: "4 cups", searchTerm: "water" },
      { amount: "2 teaspoons", searchTerm: "dashi" },
      { amount: "1/4 cup, dried", searchTerm: "wakame seaweed" },
      { amount: "1/2 block, cubed", searchTerm: "tofu" },
      { amount: "4 tablespoons", searchTerm: "miso paste" },
      { amount: "2, chopped", searchTerm: "green onions" }
    ],
    instructions: [
      "Bring water to a boil in a pot. Add dashi granules and mix until dissolved.",
      "Add the dried wakame and cubed tofu. Reduce heat and simmer for 2-3 minutes.",
      "Turn off the heat. Scoop some dashi broth into a small bowl and mix with the miso paste until smooth. Pour the miso mixture back into the pot.",
      "Garnish with chopped green onions and serve immediately. Do not boil the soup after adding miso, as it will kill the probiotics."
    ],
    cookTime: 15,
    servings: 4,
    difficulty: "Easy",
    category: "Soup"
  },
  {
    id: 43,
    name: "French Ratatouille",
    ingredients: [
      { amount: "1, cubed", searchTerm: "eggplant" },
      { amount: "1, cubed", searchTerm: "zucchini" },
      { amount: "1, cubed", searchTerm: "yellow squash" },
      { amount: "1 red, 1 yellow, chopped", searchTerm: "bell peppers" },
      { amount: "4, chopped", searchTerm: "tomatoes" },
      { amount: "3, minced", searchTerm: "garlic" },
      { amount: "3 tablespoons", searchTerm: "olive oil" },
      { amount: "1 teaspoon", searchTerm: "herbes de Provence" },
      { amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "Heat olive oil in a large pot or Dutch oven over medium heat. Add the onions, bell peppers, and garlic, and cook until softened.",
      "Stir in the eggplant, zucchini, and squash. Cook for 5-7 minutes.",
      "Add the tomatoes, herbes de Provence, salt, and pepper. Bring to a simmer.",
      "Cover and cook on low heat for 30-40 minutes, or until vegetables are tender. Stir occasionally."
    ],
    cookTime: 60,
    servings: 6,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 44,
    name: "Peruvian Lomo Saltado",
    ingredients: [
      { amount: "1 lb, cut into strips", searchTerm: "beef sirloin" },
      { amount: "1 large, cut into thick strips", searchTerm: "red onion" },
      { amount: "2 tablespoons", searchTerm: "aji amarillo paste" },
      { amount: "3 tablespoons", searchTerm: "soy sauce" },
      { amount: "1 tablespoon", searchTerm: "red wine vinegar" },
      { amount: "3, minced", searchTerm: "garlic" },
      { amount: "2, cut into wedges", searchTerm: "tomatoes" },
      { amount: "1/4 cup, chopped", searchTerm: "cilantro" },
      { amount: "2 cups, prepared", searchTerm: "french fries" },
      { amount: "2 tablespoons", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "In a hot wok or large skillet, heat vegetable oil. Add the beef strips and stir-fry quickly until browned. Remove and set aside.",
      "In the same wok, add the red onion and stir-fry for 1-2 minutes.",
      "Add the garlic, tomatoes, soy sauce, aji amarillo paste, and red wine vinegar. Cook for 1-2 minutes.",
      "Return the beef to the wok. Stir to combine with the sauce.",
      "Add the french fries and cilantro, toss everything together, and serve immediately with white rice."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 45,
    name: "Japanese Sushi Rolls (Maki)",
    ingredients: [
      { amount: "1 cup, cooked", searchTerm: "sushi rice" },
      { amount: "2 tablespoons", searchTerm: "rice vinegar" },
      { amount: "1 tablespoon", searchTerm: "sugar" },
      { amount: "1/2 teaspoon", searchTerm: "salt" },
      { amount: "4", searchTerm: "nori sheets" },
      { amount: "as needed", searchTerm: "sushi fillings" }
    ],
    instructions: [
      "In a small bowl, combine the rice vinegar, sugar, and salt to make the sushi vinegar. Stir until dissolved.",
      "Gently fold the sushi vinegar into the cooked rice. Let cool to room temperature.",
      "Place a nori sheet, shiny side down, on a bamboo sushi mat. Spread a thin, even layer of rice over the nori, leaving a 1-inch border at the top.",
      "Arrange your fillings horizontally across the center of the rice.",
      "Using the mat, roll the sushi tightly. Wet the top border of the nori to seal the roll.",
      "Slice the roll into 6-8 pieces with a sharp, wet knife."
    ],
    cookTime: 30,
    servings: 2,
    difficulty: "Hard",
    category: "Dinner"
  },
  {
    id: 46,
    name: "French Onion Soup",
    ingredients: [
      { amount: "4 large, thinly sliced", searchTerm: "onions" },
      { amount: "4 tablespoons", searchTerm: "butter" },
      { amount: "6 cups", searchTerm: "beef broth" },
      { amount: "1/2 cup", searchTerm: "white wine" },
      { amount: "4", searchTerm: "baguette slices" },
      { amount: "1 cup, shredded", searchTerm: "gruyère cheese" },
      { amount: "2", searchTerm: "thyme sprigs" },
      { amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "In a large pot, melt the butter over medium-low heat. Add the onions and cook, stirring occasionally, for 30-40 minutes until they are deeply caramelized.",
      "Increase the heat to medium. Add the white wine and scrape up any browned bits from the bottom of the pot. Cook until the wine has evaporated.",
      "Pour in the beef broth and add the thyme sprigs. Bring to a simmer, then reduce heat and let it simmer for 20-30 minutes.",
      "Season with salt and pepper. Ladle the soup into oven-safe bowls. Place a slice of toasted baguette on top of each bowl.",
      "Sprinkle a generous amount of gruyère cheese over the baguette. Broil until the cheese is melted and bubbly."
    ],
    cookTime: 90,
    servings: 4,
    difficulty: "Medium",
    category: "Soup"
  },
  {
    id: 47,
    name: "Peruvian Arroz con Pollo",
    ingredients: [
      { amount: "2 lbs", searchTerm: "chicken thighs" },
      { amount: "2 cups", searchTerm: "rice" },
      { amount: "1 cup", searchTerm: "beer" },
      { amount: "1 bunch, chopped", searchTerm: "cilantro" },
      { amount: "1, chopped", searchTerm: "yellow onion" },
      { amount: "1, chopped", searchTerm: "bell pepper" },
      { amount: "1 cup", searchTerm: "peas carrots" },
      { amount: "2 tablespoons", searchTerm: "aji amarillo paste" },
      { amount: "2 cloves, minced", searchTerm: "garlic" }
    ],
    instructions: [
      "In a large pot, brown the chicken thighs. Remove and set aside.",
      "Sauté the onion, bell pepper, and garlic until softened. Add the aji amarillo paste and cook for 2 minutes.",
      "Add the chopped cilantro and beer, stirring to combine. Bring to a boil.",
      "Add the rice, chicken, and enough water to cover the rice by about 1 inch. Season with salt.",
      "Reduce heat to low, cover, and simmer for 20 minutes. Stir in the frozen peas and carrots and cook for 5 more minutes until rice is tender."
    ],
    cookTime: 45,
    servings: 6,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 48,
    name: "Japanese Gyoza (Dumplings)",
    ingredients: [
      { amount: "30", searchTerm: "gyoza wrappers" },
      { amount: "1/2 lb", searchTerm: "ground pork" },
      { amount: "1 cup, finely chopped", searchTerm: "cabbage" },
      { amount: "1/4 cup, chopped", searchTerm: "chives" },
      { amount: "1 teaspoon, grated", searchTerm: "ginger" },
      { amount: "1 tablespoon", searchTerm: "soy sauce" },
      { amount: "1 teaspoon", searchTerm: "sesame oil" },
      { amount: "for pan-frying", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "In a large bowl, mix the ground pork, cabbage, nira, ginger, soy sauce, and sesame oil until well combined.",
      "Place a small amount of the filling in the center of a gyoza wrapper. Moisten the edges with water.",
      "Fold the wrapper in half to form a semi-circle and pleat the top edge to seal.",
      "Heat vegetable oil in a large non-stick skillet over medium-high heat. Place the gyoza in a single layer and pan-fry until the bottoms are golden brown.",
      "Pour 1/4 cup of water into the skillet. Cover and steam for 5-7 minutes until the water evaporates and the dumplings are cooked through.",
      "Serve with a dipping sauce of soy sauce and rice vinegar."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium",
    category: "Snacks"
  },
  {
    id: 49,
    name: "French Niçoise Salad",
    ingredients: [
      { amount: "6 oz", searchTerm: "tuna" },
      { amount: "2, quartered", searchTerm: "eggs" },
      { amount: "4 cups", searchTerm: "salad greens" },
      { amount: "1 cup, blanched", searchTerm: "green beans" },
      { amount: "2, chopped", searchTerm: "tomatoes" },
      { amount: "1 cup, boiled and halved", searchTerm: "potatoes" },
      { amount: "1/4 cup", searchTerm: "olives" },
      { amount: "3 tablespoons", searchTerm: "olive oil" },
      { amount: "1 tablespoon", searchTerm: "red wine vinegar" },
      { amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "In a small bowl, whisk together the olive oil, red wine vinegar, salt, and pepper to make the vinaigrette.",
      "On a large plate or platter, arrange the salad greens as a base.",
      "Artfully arrange the tuna, eggs, green beans, tomatoes, potatoes, and olives on top of the greens.",
      "Drizzle the vinaigrette evenly over the salad just before serving."
    ],
    cookTime: 25,
    servings: 2,
    difficulty: "Easy",
    category: "Salad"
  },
  {
    id: 50,
    name: "Peruvian Papa a la Huancaína",
    ingredients: [
      { amount: "4, boiled and sliced", searchTerm: "potatoes" },
      { amount: "2, seeded and deveined", searchTerm: "aji amarillo peppers" },
      { amount: "1 cup, crumbled", searchTerm: "feta cheese" },
      { amount: "1/2 cup", searchTerm: "milk" },
      { amount: "4-5", searchTerm: "soda crackers" },
      { amount: "1/4 cup", searchTerm: "vegetable oil" },
      { amount: "1", searchTerm: "garlic clove" },
      { amount: "to taste", searchTerm: "salt" }
    ],
    instructions: [
      "In a blender, combine the aji amarillo peppers, cheese, milk, soda crackers, vegetable oil, garlic, and salt.",
      "Blend until the sauce is completely smooth and has a creamy consistency.",
      "Arrange the sliced boiled potatoes on a serving platter.",
      "Pour the huancaína sauce generously over the potatoes. Garnish with hard-boiled eggs and black olives if desired."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Easy",
    category: "Snacks"
  },
  {
    id: 51,
    name: "Japanese Onigiri (Rice Balls)",
    ingredients: [
      { amount: "2 cups, cooked", searchTerm: "short-grain rice" },
      { amount: "to taste", searchTerm: "salt" },
      { amount: "as needed", searchTerm: "onigiri fillings" },
      { amount: "for wrapping", searchTerm: "nori sheets" }
    ],
    instructions: [
      "Wet your hands and sprinkle a little salt on your palms. Take a portion of the cooked rice (about 1/2 cup) and form it into a ball or triangle shape.",
      "Make a small indentation in the center of the rice ball and place your desired filling inside.",
      "Close the rice around the filling and reshape it to ensure the filling is completely covered.",
      "Wrap a strip of nori around the bottom or side of the rice ball."
    ],
    cookTime: 20,
    servings: 4,
    difficulty: "Easy",
    category: "Snacks"
  },
  {
    id: 52,
    name: "French Crêpes",
    ingredients: [
      { amount: "1 cup", searchTerm: "flour" },
      { amount: "2 large", searchTerm: "eggs" },
      { amount: "1 1/2 cups", searchTerm: "milk" },
      { amount: "2 tablespoons, melted", searchTerm: "butter" },
      { amount: "1/4 teaspoon", searchTerm: "salt" },
      { amount: "1 tablespoon (optional for sweet crepes)", searchTerm: "sugar" }
    ],
    instructions: [
      "In a large bowl, whisk together the flour, salt, and sugar (if using).",
      "In a separate bowl, whisk the eggs and milk. Slowly pour the wet ingredients into the dry ingredients, whisking continuously until a smooth batter forms.",
      "Stir in the melted butter. Let the batter rest for at least 15-20 minutes.",
      "Heat a lightly greased non-stick skillet over medium heat. Pour a small amount of batter into the pan, swirling to form a thin, even layer.",
      "Cook for about 1 minute, or until the edges are golden brown. Flip and cook for another 30 seconds.",
      "Fill with your desired sweet or savory fillings and fold or roll."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Medium",
    category: "Breakfast"
  },
  {
    id: 53,
    name: "Peruvian Pollo a la Brasa (Roasted Chicken)",
    ingredients: [
      { amount: "1, 3-4 lbs", searchTerm: "whole chicken" },
      { amount: "2 tablespoons", searchTerm: "aji panca paste" },
      { amount: "4, minced", searchTerm: "garlic" },
      { amount: "2 tablespoons", searchTerm: "soy sauce" },
      { amount: "1 teaspoon", searchTerm: "cumin" },
      { amount: "1 teaspoon", searchTerm: "paprika" },
      { amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "In a bowl, mix the aji panca paste, garlic, soy sauce, cumin, paprika, salt, and pepper to create a marinade.",
      "Pat the chicken dry and rub the marinade all over the chicken, including under the skin. Marinate for at least 4 hours, or overnight for best results.",
      "Preheat the oven to 400°F (200°C). Place the chicken on a roasting rack in a roasting pan.",
      "Roast for 1 hour to 1 hour and 15 minutes, or until a meat thermometer reads 165°F (74°C) in the thickest part of the thigh."
    ],
    cookTime: 90,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 54,
    name: "Japanese Yakitori (Grilled Skewers)",
    ingredients: [
      { amount: "1 lb, cut into cubes", searchTerm: "chicken thighs" },
      { amount: "1 bunch, cut into 1-inch pieces", searchTerm: "scallions" },
      { amount: "1/2 cup", searchTerm: "soy sauce" },
      { amount: "1/4 cup", searchTerm: "mirin" },
      { amount: "1/4 cup", searchTerm: "sake" },
      { amount: "2 tablespoons", searchTerm: "sugar" },
      { amount: "10-12", searchTerm: "bamboo skewers" }
    ],
    instructions: [
      "If using bamboo skewers, soak them in water for at least 30 minutes to prevent burning.",
      "Thread the chicken pieces and scallion pieces alternately onto the skewers.",
      "In a small saucepan, combine the soy sauce, mirin, sake, and sugar. Bring to a simmer over medium heat, stirring until the sugar dissolves. Cook for 5 minutes, or until the sauce thickens slightly.",
      "Grill the skewers on a hot grill or under a broiler, turning occasionally and basting with the sauce until the chicken is cooked through and lightly charred."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Easy",
    category: "Snacks"
  },
  {
    id: 55,
    name: "French Salad with Vinaigrette",
    ingredients: [
      { amount: "4 cups", searchTerm: "salad greens" },
      { amount: "1, finely minced", searchTerm: "shallot" },
      { amount: "1 teaspoon", searchTerm: "Dijon mustard" },
      { amount: "2 tablespoons", searchTerm: "red wine vinegar" },
      { amount: "1/2 cup", searchTerm: "olive oil" },
      { amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "In a small bowl, whisk together the minced shallot, Dijon mustard, red wine vinegar, salt, and pepper.",
      "Slowly drizzle in the olive oil while continuously whisking until the vinaigrette is emulsified.",
      "In a large bowl, toss the mixed greens with the vinaigrette just before serving. Do not over-dress the salad."
    ],
    cookTime: 10,
    servings: 4,
    difficulty: "Easy",
    category: "Salad"
  },
  {
    id: 56,
    name: "Peruvian Aji de Gallina (Creamy Chicken)",
    ingredients: [
      { amount: "2, cooked and shredded", searchTerm: "chicken breast" },
      { amount: "1/2 cup", searchTerm: "aji amarillo paste" },
      { amount: "1/2 cup, ground", searchTerm: "walnuts" },
      { amount: "1 cup", searchTerm: "milk" },
      { amount: "3-4 slices, crusts removed", searchTerm: "white bread" },
      { amount: "1/2 cup, grated", searchTerm: "parmesan cheese" },
      { amount: "1, diced", searchTerm: "yellow onion" }
    ],
    instructions: [
      "Soak the bread in milk until soft. Squeeze out excess milk and set aside.",
      "In a pot, sauté the onion until soft. Add the aji amarillo paste and cook for 2 minutes.",
      "Add the shredded chicken, soaked bread, ground walnuts, and a bit of chicken broth or water to create a sauce. Simmer for 10 minutes.",
      "Stir in the grated cheese. Serve over cooked rice and sliced boiled potatoes."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 57,
    name: "Japanese Tamagoyaki (Rolled Omelette)",
    ingredients: [
      { amount: "4 large", searchTerm: "eggs" },
      { amount: "3 tablespoons", searchTerm: "dashi broth" },
      { amount: "1 teaspoon", searchTerm: "soy sauce" },
      { amount: "1 tablespoon", searchTerm: "sugar" },
      { amount: "1 teaspoon", searchTerm: "mirin" },
      { amount: "for pan", searchTerm: "oil" }
    ],
    instructions: [
      "In a bowl, whisk the eggs until just combined (do not over-whisk). Stir in the dashi, soy sauce, sugar, and mirin.",
      "Heat a rectangular tamagoyaki pan or a small non-stick skillet over medium heat and lightly oil it.",
      "Pour a thin layer of the egg mixture into the pan to coat the bottom. As it cooks, gently push the egg to one side, forming a roll.",
      "Pour another thin layer of egg mixture into the pan, tilting to let it run under the rolled egg. Cook and roll the egg again.",
      "Repeat this process until all the egg mixture is used, creating a multi-layered omelette."
    ],
    cookTime: 15,
    servings: 2,
    difficulty: "Medium",
    category: "Breakfast"
  },
  {
    id: 58,
    name: "French Boeuf Bourguignon",
    ingredients: [
      { amount: "2 lbs", searchTerm: "beef stew meat" },
      { amount: "1 bottle", searchTerm: "red wine" },
      { amount: "2 cups", searchTerm: "beef broth" },
      { amount: "4 oz, chopped", searchTerm: "bacon" },
      { amount: "2, chopped", searchTerm: "carrots" },
      { amount: "2, chopped", searchTerm: "onions" },
      { amount: "1 lb, quartered", searchTerm: "mushrooms" },
      { amount: "4, minced", searchTerm: "garlic" }
    ],
    instructions: [
      "Cook the bacon in a large Dutch oven until crispy. Remove bacon, leaving the fat. Brown the beef in batches and set aside.",
      "Sauté the carrots and onions in the bacon fat until soft. Add the garlic and cook for 1 minute.",
      "Pour in the red wine, scraping up any browned bits. Add the beef and beef broth, bringing to a simmer.",
      "Add the mushrooms and cooked bacon. Cover and simmer on low heat for 2-3 hours, or until the beef is fork-tender. Thicken with a cornstarch slurry if desired."
    ],
    cookTime: 180,
    servings: 6,
    difficulty: "Hard",
    category: "Dinner"
  },
  {
    id: 59,
    name: "Peruvian Causa Rellena",
    ingredients: [
      { amount: "2 lbs, boiled and mashed", searchTerm: "potatoes" },
      { amount: "2 tablespoons", searchTerm: "aji amarillo paste" },
      { amount: "1/4 cup", searchTerm: "lime juice" },
      { amount: "2 tablespoons", searchTerm: "oil" },
      { amount: "2 cups", searchTerm: "chicken tuna" },
      { amount: "1/2 cup", searchTerm: "mayonnaise" },
      { amount: "1, sliced", searchTerm: "avocado" }
    ],
    instructions: [
      "In a bowl, mix the mashed potatoes with the aji amarillo paste, lime juice, salt, and oil until a smooth, colored dough forms. Divide into two equal portions.",
      "In another bowl, mix the shredded chicken or tuna with mayonnaise and a little salt and pepper.",
      "Press one portion of the potato mixture into a mold or a small pan to form the bottom layer. Spread the chicken or tuna mixture over it.",
      "Arrange the sliced avocado on top of the chicken/tuna layer.",
      "Carefully press the second portion of the potato mixture on top to form the final layer. Chill for at least 30 minutes before serving."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium",
    category: "Lunch"
  },
  {
    id: 60,
    name: "Japanese Chicken Katsu",
    ingredients: [
      { amount: "2", searchTerm: "chicken breasts" },
      { amount: "1/2 cup", searchTerm: "flour" },
      { amount: "2, beaten", searchTerm: "eggs" },
      { amount: "1 1/2 cups", searchTerm: "panko" },
      { amount: "for deep frying", searchTerm: "vegetable oil" },
      { amount: "for serving", searchTerm: "katsu sauce" }
    ],
    instructions: [
      "Pound the chicken breasts to an even thickness. Season with salt and pepper.",
      "Set up a dredging station with three shallow dishes: one with flour, one with beaten eggs, and one with panko.",
      "Dredge each chicken breast in flour, shaking off the excess. Dip in the egg, and then press firmly into the panko to coat completely.",
      "Heat vegetable oil in a deep skillet to 350°F (175°C). Carefully place the chicken cutlets in the hot oil and fry for 4-5 minutes per side, until golden brown and cooked through.",
      "Remove and drain on a wire rack. Slice and serve with rice and a side of katsu sauce."
    ],
    cookTime: 30,
    servings: 2,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 61,
    name: "French Chocolate Mousse",
    ingredients: [
      { amount: "7 oz", searchTerm: "dark chocolate" },
      { amount: "4, separated", searchTerm: "eggs" },
      { amount: "2 tablespoons", searchTerm: "butter" },
      { amount: "1/4 cup", searchTerm: "sugar" }
    ],
    instructions: [
      "Melt the chocolate and butter together in a double boiler or in a microwave, stirring until smooth. Let cool slightly.",
      "In a separate bowl, whisk the egg yolks with the sugar until pale and fluffy. Stir this into the melted chocolate mixture.",
      "In a clean bowl, beat the egg whites until stiff peaks form.",
      "Gently fold one-third of the beaten egg whites into the chocolate mixture to lighten it. Then, fold in the remaining egg whites until no streaks remain.",
      "Spoon the mousse into serving glasses and refrigerate for at least 4 hours, or overnight, until set."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Medium",
    category: "Dessert"
  },
  {
    id: 62,
    name: "Peruvian Rocoto Relleno (Stuffed Peppers)",
    ingredients: [
      { amount: "4 large", searchTerm: "rocoto peppers" },
      { amount: "1 lb", searchTerm: "ground beef" },
      { amount: "2, chopped", searchTerm: "eggs" },
      { amount: "1/4 cup, sliced", searchTerm: "black olives" },
      { amount: "1 cup, grated", searchTerm: "cheese" },
      { amount: "1, diced", searchTerm: "onion" },
      { amount: "1 teaspoon each", searchTerm: "cumin paprika" }
    ],
    instructions: [
      "Carefully remove the stems and seeds from the rocoto peppers. To reduce the heat, boil the peppers for a few minutes in water with a bit of sugar and vinegar, repeating the process a couple of times.",
      "In a skillet, cook the ground beef with the diced onion, cumin, and paprika until the beef is browned. Stir in the chopped eggs and black olives.",
      "Stuff each rocoto pepper with the beef mixture. Top each stuffed pepper with a generous layer of grated cheese.",
      "Bake at 350°F (175°C) for 20-25 minutes, until the cheese is melted and golden brown."
    ],
    cookTime: 60,
    servings: 4,
    difficulty: "Medium",
    category: "Dinner"
  },
  {
    id: 63,
    name: "Japanese Tofu Salad",
    ingredients: [
      { amount: "1 block", searchTerm: "silken tofu" },
      { amount: "4 cups", searchTerm: "mixed greens" },
      { amount: "1 tablespoon", searchTerm: "sesame seeds" },
      { amount: "2 tablespoons", searchTerm: "soy sauce" },
      { amount: "1 tablespoon", searchTerm: "rice vinegar" },
      { amount: "1 teaspoon", searchTerm: "sesame oil" },
      { amount: "1, chopped", searchTerm: "green onions" }
    ],
    instructions: [
      "Arrange the mixed greens on a large plate or in a bowl.",
      "Gently slice the silken tofu and place it on top of the greens.",
      "In a small bowl, whisk together the soy sauce, rice vinegar, and sesame oil to make the dressing.",
      "Drizzle the dressing over the tofu and greens. Sprinkle with sesame seeds and chopped green onions."
    ],
    cookTime: 10,
    servings: 2,
    difficulty: "Easy",
    category: "Salad"
  },
  {
    id: 64,
    name: "French Madeleines",
    ingredients: [
      { amount: "1/2 cup, melted", searchTerm: "butter" },
      { amount: "1 cup", searchTerm: "flour" },
      { amount: "2/3 cup", searchTerm: "sugar" },
      { amount: "2 large", searchTerm: "eggs" },
      { amount: "1/2 teaspoon", searchTerm: "baking powder" },
      { amount: "1 teaspoon", searchTerm: "vanilla extract" }
    ],
    instructions: [
      "In a bowl, whisk the eggs and sugar together until light and fluffy.",
      "Whisk in the vanilla extract.",
      "In a separate bowl, sift the flour and baking powder. Gently fold the dry ingredients into the egg mixture.",
      "Slowly fold in the melted butter until just combined. Do not overmix. Cover and refrigerate the batter for at least 1 hour.",
      "Preheat the oven to 375°F (190°C). Grease and flour a madeleine pan. Fill each mold about three-quarters full.",
      "Bake for 10-12 minutes, or until the edges are golden and the characteristic hump has formed."
    ],
    cookTime: 30,
    servings: 12,
    difficulty: "Medium",
    category: "Dessert"
  },
  
  {
    "id": 66,
    "name": "Chinese Wonton Soup",
    "cuisine": "Chinese",
    "category": "Soup",
    "description": "A light and flavorful soup with delicate wontons (dumplings) filled with seasoned meat or seafood, floating in a clear, savory broth.",
    "ingredients": [
      {
        "name": "wonton wrappers",
        "amount": "24",
        "searchTerm": "wonton wrappers"
      },
      {
        "name": "ground pork or shrimp",
        "amount": "1/2 lb",
        "searchTerm": "ground pork shrimp"
      },
      {
        "name": "soy sauce",
        "amount": "1 tbsp",
        "searchTerm": "soy sauce"
      },
      {
        "name": "sesame oil",
        "amount": "1 tsp",
        "searchTerm": "sesame oil"
      },
      {
        "name": "ginger",
        "amount": "1 tsp, grated",
        "searchTerm": "ginger"
      },
      {
        "name": "chicken or vegetable broth",
        "amount": "6 cups",
        "searchTerm": "chicken vegetable broth"
      },
      {
        "name": "bok choy",
        "amount": "2 cups, chopped",
        "searchTerm": "bok choy"
      },
      {
        "name": "green onions",
        "amount": "2, chopped",
        "searchTerm": "green onions"
      }
    ],
    "instructions": [
      "In a bowl, combine the ground pork/shrimp, soy sauce, sesame oil, and ginger to create the filling.",
      "Place a small amount of filling in the center of a wonton wrapper. Fold into a triangle and press to seal, then bring the two bottom corners together to form a pouch.",
      "Bring the broth to a simmer in a large pot. Add the wontons and cook for 3-5 minutes, or until they float and are cooked through.",
      "Add the bok choy and cook for 1 minute. Garnish with chopped green onions and serve hot."
    ],
    "cookTime": 30,
    "servings": 4,
    "difficulty": "Medium"
  },
  {
    id: 67,
    name: "Indian Chicken Tikka Masala",
    cuisine: "Indian",
    category: "Dinner",
    description: "A popular Indian dish featuring marinated and grilled chicken (tikka) served in a rich, creamy, and spiced tomato-based curry (masala).",
    ingredients: [
      { name: "chicken breast", amount: "1.5 lbs, cubed", searchTerm: "chicken breast" },
      { name: "yogurt", amount: "1/2 cup", searchTerm: "yogurt" },
      { name: "ginger-garlic paste", amount: "2 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "garam masala", amount: "1 tsp", searchTerm: "garam masala" },
      { name: "turmeric", amount: "1 tsp", searchTerm: "turmeric" },
      { name: "tomato puree", amount: "1 cup", searchTerm: "tomato puree" },
      { name: "heavy cream", amount: "1/2 cup", searchTerm: "heavy cream" },
      { name: "onion", amount: "1, diced", searchTerm: "onion" }
    ],
    instructions: [
      "Marinate the cubed chicken in yogurt, ginger-garlic paste, and half of the garam masala and turmeric for at least 30 minutes.",
      "Grill or pan-fry the chicken until cooked through and slightly charred. Set aside.",
      "In a separate pan, sauté the onion until soft. Add the remaining spices and tomato puree, cooking for 5 minutes.",
      "Stir in the heavy cream and grilled chicken. Simmer for 10-15 minutes until the sauce has thickened. Serve hot with rice or naan bread."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 68,
    name: "Mexican Tacos al Pastor",
    cuisine: "Mexican",
    category: "Dinner",
    description: "A classic Mexican street food dish of marinated pork cooked on a vertical spit, served in tortillas with pineapple, onion, and cilantro.",
    ingredients: [
      { name: "pork shoulder", amount: "1 lb, thinly sliced", searchTerm: "pork shoulder" },
      { name: "achiote paste", amount: "2 tbsp", searchTerm: "achiote paste" },
      { name: "pineapple juice", amount: "1/4 cup", searchTerm: "pineapple juice" },
      { name: "garlic cloves", amount: "2, minced", searchTerm: "garlic" },
      { name: "corn tortillas", amount: "8", searchTerm: "corn tortillas" },
      { name: "onion", amount: "1, finely diced", searchTerm: "onion" },
      { name: "cilantro", amount: "1/4 cup, chopped", searchTerm: "cilantro" },
      { name: "pineapple", amount: "1/2 cup, diced", searchTerm: "pineapple" }
    ],
    instructions: [
      "Marinate the pork slices in a mixture of achiote paste, pineapple juice, and garlic for at least 2 hours.",
      "Cook the marinated pork in a hot skillet or on a grill until cooked through and slightly crispy.",
      "Warm the corn tortillas. Fill each tortilla with the cooked pork.",
      "Top with diced onion, cilantro, and pineapple. Serve with lime wedges and salsa."
    ],
    cookTime: 35,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 69,
    name: "Chinese Fried Rice",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A quick and versatile dish of stir-fried rice with eggs, vegetables, and a choice of protein. It's a great way to use leftover rice.",
    ingredients: [
      { name: "day-old cooked rice", amount: "3 cups", searchTerm: "rice" },
      { name: "eggs", amount: "2, beaten", searchTerm: "eggs" },
      { name: "mixed vegetables (peas, carrots, corn)", amount: "1 cup", searchTerm: "mixed vegetables" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "sesame oil", amount: "1 tsp", searchTerm: "sesame oil" },
      { name: "onion", amount: "1/2, chopped", searchTerm: "onion" }
    ],
    instructions: [
      "Heat a large wok or skillet with a little oil. Scramble the eggs and set them aside.",
      "Add more oil and sauté the onion and mixed vegetables until tender-crisp.",
      "Add the day-old rice to the wok, breaking it up with a spatula. Stir-fry for 2-3 minutes.",
      "Stir in the soy sauce and sesame oil. Return the scrambled eggs to the wok and toss to combine. Serve hot."
    ],
    cookTime: 20,
    servings: 3,
    difficulty: "Easy"
  },
  {
    id: 70,
    name: "Indian Samosas",
    cuisine: "Indian",
    category: "Snacks",
    description: "A popular fried or baked pastry with a savory filling, such as spiced potatoes, onions, peas, and lentils. It's a classic street food snack.",
    ingredients: [
      { name: "all-purpose flour", amount: "2 cups", searchTerm: "flour" },
      { name: "potatoes", amount: "2, boiled and mashed", searchTerm: "potatoes" },
      { name: "green peas", amount: "1/2 cup", searchTerm: "green peas" },
      { name: "onion", amount: "1, finely chopped", searchTerm: "onion" },
      { name: "ginger", amount: "1 tsp, grated", searchTerm: "ginger" },
      { name: "garam masala", amount: "1/2 tsp", searchTerm: "garam masala" },
      { name: "vegetable oil", amount: "for frying", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "Mix flour with water and a pinch of salt to form a stiff dough. Let it rest for 15 minutes.",
      "In a pan, sauté the onion and ginger. Add the mashed potatoes, green peas, and spices. Mix well to create the filling.",
      "Roll out the dough into small circles, cut each in half, and form into cones. Fill with the potato mixture and seal the edges.",
      "Heat oil in a deep pan. Fry the samosas on low to medium heat until they are golden brown and crispy."
    ],
    cookTime: 50,
    servings: 6,
    difficulty: "Medium"
  },
  {
    id: 71,
    name: "Mexican Guacamole",
    cuisine: "Mexican",
    category: "Snacks",
    description: "A fresh and simple dip or side dish made from mashed avocados, lime juice, and various vegetables and seasonings.",
    ingredients: [
      { name: "avocados", amount: "3 ripe", searchTerm: "avocados" },
      { name: "lime", amount: "1, juiced", searchTerm: "lime" },
      { name: "red onion", amount: "1/4 cup, finely diced", searchTerm: "red onion" },
      { name: "cilantro", amount: "1/4 cup, chopped", searchTerm: "cilantro" },
      { name: "jalapeño", amount: "1, minced (optional)", searchTerm: "jalapeño" },
      { name: "salt", amount: "to taste", searchTerm: "salt" }
    ],
    instructions: [
      "Scoop the flesh of the avocados into a bowl. Mash with a fork, leaving some chunks for texture.",
      "Stir in the lime juice, red onion, cilantro, and jalapeño (if using).",
      "Season with salt to taste. Serve immediately with tortilla chips or as a side dish."
    ],
    cookTime: 10,
    servings: 4,
    difficulty: "Easy"
  },
  {
    id: 72,
    name: "Chinese Kung Pao Chicken",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A spicy, stir-fried Chinese dish made with chicken, peanuts, vegetables, and chili peppers. A classic from the Sichuan province.",
    ingredients: [
      { name: "boneless chicken thighs", amount: "1 lb, cubed", searchTerm: "chicken thighs" },
      { name: "peanuts", amount: "1/2 cup, roasted", searchTerm: "peanuts" },
      { name: "dried red chilies", amount: "6-8", searchTerm: "dried red chilies" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "rice vinegar", amount: "1 tbsp", searchTerm: "rice vinegar" },
      { name: "sugar", amount: "1 tsp", searchTerm: "sugar" },
      { name: "cornstarch", amount: "1 tsp", searchTerm: "cornstarch" },
      { name: "vegetable oil", amount: "2 tbsp", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "In a small bowl, whisk together the soy sauce, rice vinegar, sugar, and cornstarch to create the sauce.",
      "Heat a wok or large skillet over high heat. Add oil and stir-fry the chicken until browned and cooked through. Remove and set aside.",
      "Add the dried chilies to the wok and stir-fry for 30 seconds until fragrant.",
      "Add the chicken back to the wok along with the peanuts. Pour in the sauce and stir quickly until the sauce thickens and coats everything."
    ],
    cookTime: 25,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 73,
    name: "Indian Butter Chicken (Murgh Makhani)",
    cuisine: "Indian",
    category: "Dinner",
    description: "A popular mild Indian dish of chicken cooked in a rich, buttery, and tomato-based sauce, often with a hint of sweetness.",
    ingredients: [
      { name: "boneless chicken thighs", amount: "1.5 lbs, cubed", searchTerm: "chicken thighs" },
      { name: "butter", amount: "4 tbsp", searchTerm: "butter" },
      { name: "tomato puree", amount: "1.5 cups", searchTerm: "tomato puree" },
      { name: "heavy cream", amount: "1/2 cup", searchTerm: "heavy cream" },
      { name: "ginger garlic paste", amount: "2 tbsp", searchTerm: "ginger garlic paste" },
      { name: "garam masala", amount: "1 tsp", searchTerm: "garam masala" },
      { name: "sugar", amount: "1 tsp", searchTerm: "sugar" }
    ],
    instructions: [
      "Marinate the chicken in a little ginger-garlic paste and salt. Cook until browned and set aside.",
      "In a pan, melt the butter. Add the remaining ginger-garlic paste and spices, cooking for 1 minute.",
      "Stir in the tomato puree and sugar. Simmer for 10 minutes.",
      "Add the cooked chicken and heavy cream. Simmer for another 10-15 minutes until the sauce is creamy and the chicken is tender."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 74,
    name: "Mexican Enchiladas",
    cuisine: "Mexican",
    category: "Dinner",
    description: "A dish of corn tortillas rolled around a filling (like meat, cheese, or vegetables) and covered with a savory chili sauce and cheese.",
    ingredients: [
      { name: "corn tortillas", amount: "8", searchTerm: "corn tortillas" },
      { name: "cooked shredded chicken or beef", amount: "2 cups", searchTerm: "shredded chicken beef" },
      { name: "enchilada sauce", amount: "2 cups", searchTerm: "enchilada sauce" },
      { name: "cheddar or Monterey Jack cheese", amount: "1.5 cups, shredded", searchTerm: "cheddar cheese" },
      { name: "onion", amount: "1/2, chopped", searchTerm: "onion" }
    ],
    instructions: [
      "Preheat the oven to 375°F (190°C).",
      "Pour a small amount of enchilada sauce into the bottom of a baking dish.",
      "Dip each tortilla into the enchilada sauce, then fill with the shredded chicken/beef and a little cheese and onion.",
      "Roll up the tortillas and place them seam-side down in the baking dish. Pour the remaining sauce over the top.",
      "Sprinkle with the rest of the cheese. Bake for 20-25 minutes, until the cheese is melted and bubbly."
    ],
    cookTime: 40,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 75,
    name: "Chinese Egg Drop Soup",
    cuisine: "Chinese",
    category: "Soup",
    description: "A light and simple Chinese soup made with whisked eggs that are gently stirred into simmering chicken broth, creating thin ribbons of cooked egg.",
    ingredients: [
      { name: "chicken broth", amount: "4 cups", searchTerm: "chicken broth" },
      { name: "eggs", amount: "2, beaten", searchTerm: "eggs" },
      { name: "cornstarch", amount: "1 tbsp", searchTerm: "cornstarch" },
      { name: "water", amount: "2 tbsp", searchTerm: "water" },
      { name: "sesame oil", amount: "1 tsp", searchTerm: "sesame oil" },
      { name: "green onions", amount: "2, chopped", searchTerm: "green onions" }
    ],
    instructions: [
      "In a small bowl, whisk the cornstarch and water to create a slurry. Set aside.",
      "Bring the chicken broth to a simmer in a pot. Stir in the cornstarch slurry and cook until the broth thickens slightly.",
      "Slowly pour the beaten eggs into the simmering broth in a steady stream while stirring continuously with a fork or chopsticks. This creates the 'egg drops'.",
      "Remove from heat. Stir in the sesame oil and garnish with chopped green onions before serving."
    ],
    cookTime: 15,
    servings: 4,
    difficulty: "Easy"
  },
  {
    id: 76,
    name: "Indian Palak Paneer",
    cuisine: "Indian",
    category: "Dinner",
    description: "A popular vegetarian Indian dish of soft cubes of paneer (Indian cheese) simmered in a creamy and flavorful spinach gravy.",
    ingredients: [
      { name: "paneer", amount: "1 lb, cubed", searchTerm: "paneer" },
      { name: "spinach", amount: "10 oz, fresh or frozen", searchTerm: "spinach" },
      { name: "onion", amount: "1, chopped", searchTerm: "onion" },
      { name: "tomato", amount: "1, chopped", searchTerm: "tomato" },
      { name: "ginger-garlic paste", amount: "1 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "heavy cream", amount: "1/4 cup", searchTerm: "heavy cream" },
      { name: "garam masala", amount: "1 tsp", searchTerm: "garam masala" }
    ],
    instructions: [
      "If using fresh spinach, blanch it briefly in boiling water, then transfer to an ice bath. Drain and blend until smooth. If using frozen, thaw and blend.",
      "In a pan, sauté the onion until soft. Add the ginger-garlic paste and cook for 1 minute.",
      "Add the chopped tomato and cook until it breaks down. Stir in the garam masala.",
      "Pour the blended spinach puree into the pan. Stir in the heavy cream and cubed paneer. Simmer for 5-7 minutes until the flavors meld."
    ],
    cookTime: 35,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 77,
    name: "Mexican Chiles Rellenos",
    cuisine: "Mexican",
    category: "Dinner",
    description: "A classic Mexican dish of roasted poblano peppers stuffed with cheese or meat, dipped in an egg batter, and fried until golden brown.",
    ingredients: [
      { name: "poblano peppers", amount: "4 large", searchTerm: "poblano peppers" },
      { name: "Monterey Jack cheese", amount: "8 oz, sliced", searchTerm: "Monterey Jack cheese" },
      { name: "eggs", amount: "3, separated", searchTerm: "eggs" },
      { name: "all-purpose flour", amount: "2 tbsp", searchTerm: "flour" },
      { name: "vegetable oil", amount: "for frying", searchTerm: "vegetable oil" },
      { name: "tomato sauce or salsa", amount: "for serving", searchTerm: "tomato sauce salsa" }
    ],
    instructions: [
      "Roast the poblano peppers over an open flame or under a broiler until the skin is charred and blistered. Place in a plastic bag for 10 minutes to steam.",
      "Peel the charred skin from the peppers and carefully make a slit down the side to remove the seeds and veins. Stuff each pepper with cheese slices.",
      "In a bowl, beat the egg whites until stiff peaks form. In a separate bowl, beat the egg yolks. Gently fold the yolks into the whites.",
      "Dredge the stuffed peppers in flour. Dip each pepper in the egg batter, making sure it is fully coated.",
      "Heat a large skillet with oil over medium-high heat. Fry the peppers, turning once, until the batter is golden brown and the cheese is melted."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Hard"
  },
  {
    id: 78,
    name: "Chinese Hot and Sour Soup",
    cuisine: "Chinese",
    category: "Soup",
    description: "A spicy and tangy Chinese soup made with ingredients like mushrooms, bamboo shoots, tofu, and shredded pork or chicken, seasoned with vinegar and white pepper.",
    ingredients: [
      { name: "chicken or vegetable broth", amount: "6 cups", searchTerm: "chicken vegetable broth" },
      { name: "firm tofu", amount: "1/2 block, shredded", searchTerm: "tofu" },
      { name: "bamboo shoots", amount: "1/2 cup, shredded", searchTerm: "bamboo shoots" },
      { name: "dried shiitake mushrooms", amount: "4, rehydrated and sliced", searchTerm: "shiitake mushrooms" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "rice vinegar", amount: "3 tbsp", searchTerm: "rice vinegar" },
      { name: "white pepper", amount: "1 tsp", searchTerm: "white pepper" },
      { name: "cornstarch slurry", amount: "2 tbsp", searchTerm: "cornstarch slurry" }
    ],
    instructions: [
      "Bring the broth to a boil. Add the mushrooms, bamboo shoots, and tofu. Reduce heat and simmer for 5 minutes.",
      "Stir in the soy sauce, rice vinegar, and white pepper.",
      "Stir in the cornstarch slurry and cook for 1-2 minutes until the soup thickens.",
      "Serve hot, with a few drops of sesame oil."
    ],
    cookTime: 25,
    servings: 6,
    difficulty: "Easy"
  },
  {
    id: 79,
    name: "Indian Aloo Gobi",
    cuisine: "Indian",
    category: "Side Dish",
    description: "A classic vegetarian Indian dish of potatoes (aloo) and cauliflower (gobi) cooked with a blend of fragrant spices.",
    ingredients: [
      { name: "potatoes", amount: "2, peeled and cubed", searchTerm: "potatoes" },
      { name: "cauliflower", amount: "1 head, cut into florets", searchTerm: "cauliflower" },
      { name: "onion", amount: "1, chopped", searchTerm: "onion" },
      { name: "ginger-garlic paste", amount: "1 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "turmeric", amount: "1 tsp", searchTerm: "turmeric" },
      { name: "cumin powder", amount: "1 tsp", searchTerm: "cumin powder" },
      { name: "coriander powder", amount: "1 tsp", searchTerm: "coriander powder" }
    ],
    instructions: [
      "In a large pan, heat some oil. Add the onions and cook until soft.",
      "Add the ginger-garlic paste and cook for 1 minute until fragrant.",
      "Stir in the turmeric, cumin, and coriander powders. Cook for 30 seconds.",
      "Add the cubed potatoes and cauliflower florets. Stir to coat everything in the spices.",
      "Add a splash of water, cover, and cook on low heat for 15-20 minutes, or until the vegetables are tender. Stir occasionally."
    ],
    cookTime: 40,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 80,
    name: "Mexican Pozole Rojo",
    cuisine: "Mexican",
    category: "Soup",
    description: "A hearty and traditional Mexican stew made with hominy and meat, such as pork, and seasoned with a red chili-based broth.",
    ingredients: [
      { name: "pork shoulder", amount: "2 lbs, cubed", searchTerm: "pork shoulder" },
      { name: "dried ancho or guajillo chilies", amount: "6-8", searchTerm: "dried chilies" },
      { name: "hominy", amount: "1, 25-oz can, rinsed", searchTerm: "hominy" },
      { name: "onion", amount: "1 large", searchTerm: "onion" },
      { name: "garlic cloves", amount: "4", searchTerm: "garlic" },
      { name: "cumin", amount: "1 tsp", searchTerm: "cumin" },
      { name: "oregano", amount: "1 tsp", searchTerm: "oregano" }
    ],
    instructions: [
      "In a large pot, simmer the pork with half an onion and two garlic cloves until tender.",
      "Toast the dried chilies in a dry pan until fragrant. Rehydrate them in hot water for 20 minutes. Blend the rehydrated chilies with a little water, the remaining onion and garlic, cumin, and oregano to create a smooth sauce.",
      "Remove the cooked pork from the pot and shred it. Strain the cooking broth and set aside. Return the shredded pork to the pot.",
      "Pour the blended chili sauce through a strainer into the pot with the pork. Add the hominy and enough reserved broth to achieve your desired consistency. Simmer for at least 30 minutes to allow the flavors to meld."
    ],
    cookTime: 120,
    servings: 6,
    difficulty: "Hard"
  },
  {
    id: 81,
    name: "American Macaroni and Cheese",
    cuisine: "American",
    category: "Dinner",
    description: "A comforting and classic American dish of cooked macaroni pasta in a creamy, rich, and savory cheese sauce.",
    ingredients: [
      { name: "elbow macaroni", amount: "1 lb", searchTerm: "macaroni" },
      { name: "unsalted butter", amount: "1/4 cup", searchTerm: "butter" },
      { name: "all-purpose flour", amount: "1/4 cup", searchTerm: "flour" },
      { name: "milk", amount: "3 cups", searchTerm: "milk" },
      { name: "cheddar cheese", amount: "2 cups, shredded", searchTerm: "cheddar cheese" },
      { name: "Monterey Jack cheese", amount: "1 cup, shredded", searchTerm: "Monterey Jack cheese" },
      { name: "salt", amount: "1 tsp", searchTerm: "salt" },
      { name: "black pepper", amount: "1/2 tsp", searchTerm: "black pepper" }
    ],
    instructions: [
      "Cook the macaroni according to package directions. Drain and set aside.",
      "In a large saucepan, melt the butter over medium heat. Whisk in the flour and cook for 1 minute to create a roux.",
      "Gradually whisk in the milk until the mixture is smooth and thickened.",
      "Reduce the heat to low. Add the shredded cheeses, stirring until they are completely melted and the sauce is smooth.",
      "Stir in the cooked macaroni, salt, and pepper until well combined. Serve immediately."
    ],
    cookTime: 30,
    servings: 6,
    difficulty: "Easy"
  },
  {
    id: 82,
    name: "American Pancakes",
    cuisine: "American",
    category: "Breakfast",
    description: "Fluffy, thick pancakes that are a staple of the American breakfast, often served with butter and maple syrup.",
    ingredients: [
      { name: "all-purpose flour", amount: "1 1/2 cups", searchTerm: "flour" },
      { name: "baking powder", amount: "3 1/2 tsp", searchTerm: "baking powder" },
      { name: "salt", amount: "1/4 tsp", searchTerm: "salt" },
      { name: "sugar", amount: "1 tbsp", searchTerm: "sugar" },
      { name: "milk", amount: "1 1/4 cups", searchTerm: "milk" },
      { name: "egg", amount: "1 large", searchTerm: "egg" },
      { name: "butter", amount: "3 tbsp, melted", searchTerm: "butter" }
    ],
    instructions: [
      "In a large bowl, whisk together the flour, baking powder, salt, and sugar.",
      "In a separate bowl, whisk the milk, egg, and melted butter until combined.",
      "Pour the wet ingredients into the dry ingredients and mix with a spoon until just combined. Don't over mix, the batter should be lumpy.",
      "Heat a griddle or non-stick skillet, melt 1-2 Tbsp butter, over medium-high heat. Pour 1/4 cup of batter for each pancake.",
      "Cook for 2-3 minutes, or until bubbles form on the surface and the edges look dry. Flip and cook for another 1-2 minutes until golden brown."
    ],
    cookTime: 20,
    servings: 4,
    difficulty: "Easy"
  },
  {
    id: 83,
    name: "American Chili Con Carne",
    cuisine: "American",
    category: "Dinner",
    description: "A hearty and flavorful stew of ground beef, beans, and tomatoes, seasoned with chili powder and other spices. A quintessential comfort food.",
    ingredients: [
      { name: "ground beef", amount: "1.5 lbs", searchTerm: "ground beef" },
      { name: "canned kidney beans", amount: "1, 15-oz can, rinsed", searchTerm: "kidney beans" },
      { name: "canned diced tomatoes", amount: "1, 28-oz can, undrained", searchTerm: "diced tomatoes" },
      { name: "onion", amount: "1, chopped", searchTerm: "onion" },
      { name: "garlic cloves", amount: "2, minced", searchTerm: "garlic" },
      { name: "chili powder", amount: "2 tbsp", searchTerm: "chili powder" },
      { name: "cumin", amount: "1 tsp", searchTerm: "cumin" },
      { name: "beef broth", amount: "1 cup", searchTerm: "beef broth" }
    ],
    instructions: [
      "In a large pot or Dutch oven, brown the ground beef over medium-high heat. Drain excess fat.",
      "Add the chopped onion and garlic, and cook until the onion is soft.",
      "Stir in the chili powder and cumin, cooking for 1 minute until fragrant.",
      "Add the diced tomatoes, kidney beans, and beef broth. Stir to combine.",
      "Bring the chili to a simmer, then reduce heat to low. Cover and cook for at least 30 minutes, or longer for a richer flavor. Serve with shredded cheese and sour cream."
    ],
    cookTime: 60,
    servings: 6,
    difficulty: "Easy"
  },
  {
    id: 84,
    name: "American Meatloaf",
    cuisine: "American",
    category: "Dinner",
    description: "A classic American dinner of a loaf-shaped mixture of ground meat, breadcrumbs, and seasonings, often topped with a ketchup glaze.",
    ingredients: [
      { name: "ground beef", amount: "2 lbs", searchTerm: "ground beef" },
      { name: "bread crumbs", amount: "1 cup", searchTerm: "bread crumbs" },
      { name: "egg", amount: "1, beaten", searchTerm: "egg" },
      { name: "onion", amount: "1/2 cup, finely chopped", searchTerm: "onion" },
      { name: "ketchup", amount: "1/2 cup", searchTerm: "ketchup" },
      { name: "mustard", amount: "1 tbsp", searchTerm: "mustard" },
      { name: "salt", amount: "1 tsp", searchTerm: "salt" },
      { name: "black pepper", amount: "1/2 tsp", searchTerm: "black pepper" }
    ],
    instructions: [
      "Preheat the oven to 350°F (175°C).",
      "In a large bowl, combine the ground beef, bread crumbs, beaten egg, chopped onion, salt, and pepper. Mix until just combined, being careful not to overwork the meat.",
      "Shape the mixture into a loaf and place it in a loaf pan or on a baking sheet.",
      "In a small bowl, mix the ketchup and mustard to create the glaze. Spread the glaze evenly over the top of the meatloaf.",
      "Bake for 60-75 minutes, or until the internal temperature reaches 160°F (71°C). Let it rest for 10 minutes before slicing."
    ],
    cookTime: 90,
    servings: 6,
    difficulty: "Medium"
  },
  {
    id: 85,
    name: "Classic Apple Pie",
    cuisine: "American",
    category: "Dessert",
    description: "A traditional American dessert of a flaky pie crust filled with a sweet and spiced apple filling.",
    ingredients: [
      { name: "pie crust dough", amount: "1 package (2 crusts)", searchTerm: "pie crust dough" },
      { name: "apples (e.g., Granny Smith)", amount: "6 cups, peeled and sliced", searchTerm: "apples" },
      { name: "sugar", amount: "3/4 cup", searchTerm: "sugar" },
      { name: "all-purpose flour", amount: "2 tbsp", searchTerm: "flour" },
      { name: "cinnamon", amount: "1 tsp", searchTerm: "cinnamon" },
      { name: "nutmeg", amount: "1/4 tsp", searchTerm: "nutmeg" },
      { name: "butter", amount: "2 tbsp, cut into small pieces", searchTerm: "butter" }
    ],
    instructions: [
      "Preheat the oven to 425°F (220°C).",
      "In a large bowl, toss the sliced apples with the sugar, flour, cinnamon, and nutmeg until well coated.",
      "Place one pie crust in a 9-inch pie dish. Pour the apple mixture into the dish and dot with the small pieces of butter.",
      "Place the second pie crust over the filling. Trim and crimp the edges to seal. Cut a few small slits in the top crust to allow steam to escape.",
      "Bake for 15 minutes, then reduce the oven temperature to 375°F (190°C) and bake for another 40-50 minutes, or until the crust is golden brown and the filling is bubbly."
    ],
    cookTime: 75,
    servings: 8,
    difficulty: "Medium"
  },
  {
    id: 86,
    name: "American Coleslaw",
    cuisine: "American",
    category: "Side Dish",
    description: "A popular American side dish of shredded cabbage and carrots, coated in a creamy dressing.",
    ingredients: [
      { name: "cabbage", amount: "1 head, shredded", searchTerm: "cabbage" },
      { name: "carrots", amount: "2, shredded", searchTerm: "carrots" },
      { name: "mayonnaise", amount: "1/2 cup", searchTerm: "mayonnaise" },
      { name: "vinegar (apple cider or white)", amount: "2 tbsp", searchTerm: "vinegar" },
      { name: "sugar", amount: "1 tbsp", searchTerm: "sugar" },
      { name: "salt and pepper", amount: "to taste", searchTerm: "salt pepper" }
    ],
    instructions: [
      "In a large bowl, combine the shredded cabbage and carrots.",
      "In a separate small bowl, whisk together the mayonnaise, vinegar, sugar, salt, and pepper to create the dressing.",
      "Pour the dressing over the cabbage mixture and toss until everything is well coated.",
      "Cover and refrigerate for at least 30 minutes before serving to allow the flavors to meld."
    ],
    cookTime: 15,
    servings: 8,
    difficulty: "Easy"
  },
  {
    id: 87,
    name: "American BBQ Pulled Pork Sandwich",
    cuisine: "American",
    category: "Dinner",
    description: "A slow-cooked and tender pork dish, shredded and mixed with a sweet and tangy barbecue sauce, served on a bun.",
    ingredients: [
      { name: "pork shoulder (boston butt)", amount: "4 lbs", searchTerm: "pork shoulder" },
      { name: "BBQ rub", amount: "1/4 cup", searchTerm: "BBQ rub" },
      { name: "BBQ sauce", amount: "1 1/2 cups", searchTerm: "BBQ sauce" },
      { name: "onion", amount: "1, sliced", searchTerm: "onion" },
      { name: "buns", amount: "8", searchTerm: "buns" }
    ],
    instructions: [
      "Rub the pork shoulder generously with the BBQ rub. Place it in a slow cooker with the sliced onion.",
      "Cook on low for 8-10 hours, or until the pork is very tender and easily shreds.",
      "Remove the pork from the slow cooker, reserving the juices. Shred the pork using two forks, discarding any large pieces of fat.",
      "Return the shredded pork to the slow cooker. Stir in the BBQ sauce and some of the reserved cooking juices until the pork is well-coated and moist.",
      "Serve the pulled pork hot on buns."
    ],
    cookTime: 540,
    servings: 8,
    difficulty: "Easy"
  },
  {
    id: 88,
    name: "Chinese Spring Rolls",
    cuisine: "Chinese",
    category: "Snacks",
    description: "Crispy fried rolls filled with shredded vegetables and sometimes meat, often served with a dipping sauce.",
    ingredients: [
      { name: "spring roll wrappers", amount: "20", searchTerm: "spring roll wrappers" },
      { name: "cabbage", amount: "2 cups, shredded", searchTerm: "cabbage" },
      { name: "carrots", amount: "1 cup, shredded", searchTerm: "carrots" },
      { name: "mushrooms", amount: "1/2 cup, sliced", searchTerm: "mushrooms" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "sesame oil", amount: "1 tsp", searchTerm: "sesame oil" },
      { name: "vegetable oil", amount: "for frying", searchTerm: "vegetable oil" }
    ],
    instructions: [
      "In a large pan, stir-fry the cabbage, carrots, and mushrooms until tender-crisp. Season with soy sauce and sesame oil. Let the filling cool completely.",
      "Lay a spring roll wrapper on a flat surface. Place a spoonful of the filling near one corner. Fold in the sides and roll tightly to form a log.",
      "Heat vegetable oil in a deep skillet or wok to 350°F (175°C). Carefully place the spring rolls in the hot oil and fry until golden brown and crispy on all sides.",
      "Remove and drain on paper towels. Serve hot with a dipping sauce."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 89,
    name: "Indian Naan Bread",
    cuisine: "Indian",
    category: "Bread",
    description: "A soft, leavened flatbread that is a staple of Indian cuisine, traditionally baked in a tandoor oven. It's perfect for scooping up curries.",
    ingredients: [
      { name: "all-purpose flour", amount: "2 1/2 cups", searchTerm: "flour" },
      { name: "plain yogurt", amount: "1/2 cup", searchTerm: "yogurt" },
      { name: "warm water", amount: "1/2 cup", searchTerm: "warm water" },
      { name: "active dry yeast", amount: "1 tsp", searchTerm: "yeast" },
      { name: "sugar", amount: "1 tbsp", searchTerm: "sugar" },
      { name: "salt", amount: "1 tsp", searchTerm: "salt" },
      { name: "butter", amount: "2 tbsp, melted", searchTerm: "butter" }
    ],
    instructions: [
      "In a large bowl, whisk together the warm water, yeast, and sugar. Let it sit for 5 minutes until it becomes foamy.",
      "Stir in the yogurt, salt, and half of the flour. Gradually add the remaining flour, kneading the dough until it's smooth and elastic.",
      "Place the dough in a greased bowl, cover, and let it rise in a warm place for 1-2 hours until doubled in size.",
      "Divide the dough into 8-10 pieces. Roll each piece into an oval shape.",
      "Cook each naan on a hot, dry skillet or cast-iron pan for 2-3 minutes per side, until puffy and browned in spots. Brush with melted butter."
    ],
    cookTime: 90,
    servings: 8,
    difficulty: "Medium"
  },
  {
    id: 90,
    name: "Mexican Fajitas",
    cuisine: "Mexican",
    category: "Dinner",
    description: "A popular Tex-Mex dish of marinated grilled meat, typically beef or chicken, served with sautéed bell peppers and onions, and warm tortillas.",
    ingredients: [
      { name: "steak or chicken breast", amount: "1.5 lbs, sliced into strips", searchTerm: "steak chicken" },
      { name: "bell peppers", amount: "3, sliced (various colors)", searchTerm: "bell peppers" },
      { name: "onion", amount: "1, sliced", searchTerm: "onion" },
      { name: "lime juice", amount: "1/4 cup", searchTerm: "lime juice" },
      { name: "chili powder", amount: "1 tbsp", searchTerm: "chili powder" },
      { name: "cumin", amount: "1 tsp", searchTerm: "cumin" },
      { name: "tortillas", amount: "12", searchTerm: "tortillas" }
    ],
    instructions: [
      "In a bowl, combine the sliced meat, lime juice, chili powder, and cumin. Marinate for at least 30 minutes.",
      "Heat a large skillet or cast-iron pan over high heat. Add the marinated meat and cook until browned. Remove and set aside.",
      "In the same pan, add a little oil and sauté the sliced bell peppers and onion until tender-crisp.",
      "Return the cooked meat to the pan with the vegetables. Toss to combine and heat through.",
      "Serve the fajita mixture hot with warm tortillas and your favorite toppings like sour cream and salsa."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Easy"
  },
  {
    id: 91,
    name: "Chinese Mapo Tofu",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A classic spicy and aromatic Sichuan dish of soft tofu set in a spicy, oily sauce with ground beef or pork.",
    ingredients: [
      { name: "firm tofu", amount: "1 block, cubed", searchTerm: "tofu" },
      { name: "ground pork or beef", amount: "1/4 lb", searchTerm: "ground pork beef" },
      { name: "doubanjiang", amount: "2 tbsp", searchTerm: "doubanjiang" },
      { name: "fermented black beans", amount: "1 tbsp, mashed", searchTerm: "fermented black beans" },
      { name: "Sichuan peppercorns", amount: "1 tsp, ground", searchTerm: "Sichuan peppercorns" },
      { name: "chicken broth", amount: "1 cup", searchTerm: "chicken broth" },
      { name: "cornstarch slurry", amount: "1 tbsp", searchTerm: "cornstarch slurry" },
      { name: "green onions", amount: "2, chopped", searchTerm: "green onions" }
    ],
    instructions: [
      "Blanch the cubed tofu in boiling water for a few minutes. Drain and set aside.",
      "In a wok, stir-fry the ground meat until browned. Add the doubanjiang and fermented black beans and cook until fragrant.",
      "Pour in the chicken broth and bring to a simmer. Add the blanched tofu cubes, gently stirring to combine.",
      "Stir in the cornstarch slurry and cook for 1-2 minutes until the sauce thickens. Sprinkle with ground Sichuan peppercorns and chopped green onions before serving."
    ],
    cookTime: 25,
    servings: 2,
    difficulty: "Medium"
  },
  {
    id: 92,
    name: "Indian Chicken Curry",
    cuisine: "Indian",
    category: "Dinner",
    description: "A general term for a variety of chicken dishes with a rich, aromatic, and savory sauce, often made with tomatoes, onions, ginger, and a blend of spices.",
    ingredients: [
      { name: "chicken thighs or breast", amount: "1.5 lbs, cubed", searchTerm: "chicken thighs breast" },
      { name: "onion", amount: "1, chopped", searchTerm: "onion" },
      { name: "tomatoes", amount: "2, pureed", searchTerm: "tomatoes" },
      { name: "ginger-garlic paste", amount: "1 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "garam masala", amount: "1 tsp", searchTerm: "garam masala" },
      { name: "turmeric", amount: "1/2 tsp", searchTerm: "turmeric" },
      { name: "cumin", amount: "1 tsp", searchTerm: "cumin" },
      { name: "cilantro", amount: "1/4 cup, chopped", searchTerm: "cilantro" }
    ],
    instructions: [
      "In a large pot, sauté the onion until soft. Add the ginger-garlic paste and cook for 1 minute.",
      "Add the pureed tomatoes and cook until the oil begins to separate from the sauce.",
      "Stir in the spices (garam masala, turmeric, cumin) and cook for another minute.",
      "Add the cubed chicken and stir to coat. Pour in a little water or broth, cover, and simmer for 20-30 minutes, or until the chicken is cooked through.",
      "Garnish with fresh cilantro and serve with rice or naan."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 93,
    name: "Mexican Pozole Verde",
    cuisine: "Mexican",
    category: "Soup",
    description: "A vibrant green variation of the traditional Mexican pozole stew, made with hominy and meat in a rich broth of tomatillos, cilantro, and green chilies.",
    ingredients: [
      { name: "pork shoulder or chicken", amount: "2 lbs, cubed", searchTerm: "pork chicken" },
      { name: "tomatillos", amount: "1 lb, husked and rinsed", searchTerm: "tomatillos" },
      { name: "poblano peppers", amount: "2", searchTerm: "poblano peppers" },
      { name: "jalapeños", amount: "1-2", searchTerm: "jalapeños" },
      { name: "hominy", amount: "1, 25-oz can, rinsed", searchTerm: "hominy" },
      { name: "cilantro", amount: "1 bunch", searchTerm: "cilantro" },
      { name: "onion", amount: "1/2", searchTerm: "onion" },
      { name: "garlic cloves", amount: "2", searchTerm: "garlic" }
    ],
    instructions: [
      "Boil the pork or chicken with half an onion and two garlic cloves until tender. Remove the meat and shred it, reserving the broth.",
      "Boil the tomatillos, poblano peppers, and jalapeños until soft. Blend them with the cilantro, remaining onion, and garlic until smooth.",
      "In a pot, combine the reserved broth and the blended green sauce. Bring to a simmer.",
      "Add the shredded meat and hominy to the pot. Simmer for at least 20 minutes to allow the flavors to combine.",
      "Serve hot with a variety of toppings like shredded lettuce, radishes, and lime wedges."
    ],
    cookTime: 120,
    servings: 6,
    difficulty: "Hard"
  },
  {
    id: 94,
    name: "Chinese Orange Chicken",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A popular American Chinese dish of battered and deep-fried chicken pieces coated in a sweet and tangy orange-flavored sauce.",
    ingredients: [
      { name: "boneless chicken breast or thighs", amount: "1 lb, cubed", searchTerm: "chicken breast thighs" },
      { name: "cornstarch", amount: "1/2 cup", searchTerm: "cornstarch" },
      { name: "eggs", amount: "2, beaten", searchTerm: "eggs" },
      { name: "vegetable oil", amount: "for deep frying", searchTerm: "vegetable oil" },
      { name: "orange juice", amount: "1 cup", searchTerm: "orange juice" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "sugar", amount: "1/4 cup", searchTerm: "sugar" },
      { name: "rice vinegar", amount: "1 tbsp", searchTerm: "rice vinegar" }
    ],
    instructions: [
      "Toss the chicken cubes with a little salt and pepper. Dredge them in cornstarch, then dip in the beaten egg, and dredge in cornstarch again.",
      "Heat oil in a deep pan to 350°F (175°C). Fry the chicken in batches until golden brown and cooked through. Remove and drain on a wire rack.",
      "In a small saucepan, whisk together the orange juice, soy sauce, sugar, and rice vinegar. Bring to a simmer, then stir in a cornstarch slurry to thicken the sauce.",
      "Toss the fried chicken in the sauce until each piece is well-coated. Serve hot with rice."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 95,
    name: "Indian Biryani",
    cuisine: "Indian",
    category: "Dinner",
    description: "A flavorful and aromatic mixed rice dish made with spices, vegetables, and meat, such as chicken, lamb, or goat. It's a celebratory dish.",
    ingredients: [
      { name: "basmati rice", amount: "2 cups", searchTerm: "basmati rice" },
      { name: "chicken or lamb", amount: "1 lb, cubed", searchTerm: "chicken lamb" },
      { name: "onion", amount: "1, thinly sliced", searchTerm: "onion" },
      { name: "ginger-garlic paste", amount: "2 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "yogurt", amount: "1/2 cup", searchTerm: "yogurt" },
      { name: "biryani masala", amount: "2 tbsp", searchTerm: "biryani masala" },
      { name: "mint and cilantro", amount: "1/2 cup, chopped", searchTerm: "mint cilantro" },
      { name: "vegetable oil or ghee", amount: "3 tbsp", searchTerm: "oil ghee" }
    ],
    instructions: [
      "Wash the rice and soak in water for 30 minutes. Drain and cook until it is 70% done. Set aside.",
      "Marinate the chicken or lamb in yogurt, biryani masala, ginger-garlic paste, and salt for at least 1 hour.",
      "In a large pot, sauté the onions until golden brown. Add the marinated meat and cook until it's sealed. Stir in the chopped mint and cilantro.",
      "Layer the partially cooked rice over the meat. Add a little water, cover, and cook on very low heat (dum method) for 20-25 minutes until the rice is fully cooked and the flavors have melded."
    ],
    cookTime: 90,
    servings: 4,
    difficulty: "Hard"
  },
  {
    id: 96,
    name: "Mexican Carnitas",
    cuisine: "Mexican",
    category: "Dinner",
    description: "A traditional Mexican dish of tender, juicy, and crispy slow-cooked pork. It's often used as a filling for tacos or burritos.",
    ingredients: [
      { name: "pork shoulder", amount: "3 lbs, cubed", searchTerm: "pork shoulder" },
      { name: "orange", amount: "1, quartered", searchTerm: "orange" },
      { name: "onion", amount: "1, quartered", searchTerm: "onion" },
      { name: "garlic cloves", amount: "4", searchTerm: "garlic" },
      { name: "bay leaves", amount: "2", searchTerm: "bay leaves" },
      { name: "salt", amount: "2 tsp", searchTerm: "salt" },
      { name: "water", amount: "to cover", searchTerm: "water" }
    ],
    instructions: [
      "Place the cubed pork shoulder in a large pot or Dutch oven. Add the quartered orange, onion, garlic cloves, bay leaves, and salt.",
      "Pour in enough water to just cover the pork. Bring to a boil, then reduce the heat to a low simmer.",
      "Cook for 3-4 hours, or until the pork is very tender and falls apart easily. The water should evaporate, leaving the pork to fry in its own fat.",
      "Shred the pork with two forks. Continue to cook until the edges are golden and crispy. Serve in tortillas with your favorite toppings."
    ],
    cookTime: 240,
    servings: 6,
    difficulty: "Medium"
  },
  {
    id: 97,
    name: "Chinese Peking Duck",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A famous Chinese dish from Beijing. The duck is roasted and served with its crispy skin and tender meat, along with thin pancakes, scallions, and hoisin sauce.",
    ingredients: [
      { name: "duck", amount: "1 whole", searchTerm: "duck" },
      { name: "honey", amount: "1/4 cup", searchTerm: "honey" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "vinegar", amount: "1 tbsp", searchTerm: "vinegar" },
      { name: "ginger", amount: "1, sliced", searchTerm: "ginger" },
      { name: "scallions", amount: "1 bunch", searchTerm: "scallions" },
      { name: "pancakes", amount: "for serving", searchTerm: "pancakes" },
      { name: "hoisin sauce", amount: "for serving", searchTerm: "hoisin sauce" }
    ],
    instructions: [
      "Prepare the duck by patting it dry. Puncture the skin all over. In a small bowl, mix the honey, soy sauce, and vinegar to create a glaze.",
      "Pour boiling water over the duck to tighten the skin. Air-dry the duck for at least 4 hours, or overnight, in the refrigerator.",
      "Preheat the oven to 375°F (190°C). Roast the duck for 1 hour, then brush with the honey glaze and continue to roast for another 30-45 minutes, or until the skin is dark and crispy.",
      "Carve the duck, slicing the crispy skin and meat. Serve with thin pancakes, sliced scallions, and hoisin sauce."
    ],
    cookTime: 150,
    servings: 4,
    difficulty: "Hard"
  },
  {
    id: 98,
    name: "Indian Tandoori Chicken",
    cuisine: "Indian",
    category: "Dinner",
    description: "A popular Indian dish of chicken marinated in yogurt and spices, traditionally cooked in a tandoor (clay oven) but can be grilled or baked at home.",
    ingredients: [
      { name: "chicken thighs or drumsticks", amount: "2 lbs", searchTerm: "chicken thighs drumsticks" },
      { name: "plain yogurt", amount: "1 cup", searchTerm: "yogurt" },
      { name: "ginger-garlic paste", amount: "2 tbsp", searchTerm: "ginger-garlic paste" },
      { name: "garam masala", amount: "1 tbsp", searchTerm: "garam masala" },
      { name: "cumin powder", amount: "1 tsp", searchTerm: "cumin powder" },
      { name: "turmeric", amount: "1/2 tsp", searchTerm: "turmeric" },
      { name: "red chili powder", amount: "1 tsp", searchTerm: "chili powder" },
      { name: "lemon juice", amount: "1 tbsp", searchTerm: "lemon juice" }
    ],
    instructions: [
      "Score the chicken with a few deep cuts. In a large bowl, whisk together the yogurt, ginger-garlic paste, spices, and lemon juice to create the marinade.",
      "Add the chicken to the marinade, making sure each piece is well-coated. Cover and refrigerate for at least 4 hours, or overnight.",
      "Preheat the oven to 425°F (220°C). Place the marinated chicken on a wire rack over a baking sheet.",
      "Bake for 25-30 minutes, or until the chicken is cooked through and lightly charred. You can also grill the chicken for a smoky flavor."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium"
  },
  {
    id: 99,
    name: "Mexican Ceviche",
    cuisine: "Mexican",
    category: "Appetizer",
    description: "A fresh seafood dish where raw fish or shrimp is cured in citrus juices, typically lime, and mixed with fresh vegetables like onions, cilantro, and tomatoes.",
    ingredients: [
      { name: "firm white fish or shrimp", amount: "1 lb, diced", searchTerm: "white fish shrimp" },
      { name: "lime juice", amount: "1 cup", searchTerm: "lime juice" },
      { name: "red onion", amount: "1/2, finely diced", searchTerm: "red onion" },
      { name: "tomatoes", amount: "2, diced", searchTerm: "tomatoes" },
      { name: "jalapeño", amount: "1, minced", searchTerm: "jalapeño" },
      { name: "cilantro", amount: "1/4 cup, chopped", searchTerm: "cilantro" },
      { name: "avocado", amount: "1, cubed", searchTerm: "avocado" }
    ],
    instructions: [
      "Place the diced fish or shrimp in a glass bowl. Pour the lime juice over the seafood, making sure it is fully submerged. Refrigerate for 30 minutes to 1 hour, or until the seafood turns opaque.",
      "Once the seafood is 'cooked' by the acid, gently stir in the red onion, tomatoes, jalapeño, and cilantro.",
      "Just before serving, gently fold in the cubed avocado. Season with salt and pepper to taste. Serve with tortilla chips."
    ],
    cookTime: 30,
    servings: 4,
    difficulty: "Easy"
  },
  {
    id: 100,
    name: "Chinese Char Siu (BBQ Pork)",
    cuisine: "Chinese",
    category: "Dinner",
    description: "A popular Cantonese dish of barbecued pork. The pork is marinated in a sweet and savory sauce, then roasted until it's tender and slightly charred.",
    ingredients: [
      { name: "pork shoulder", amount: "1.5 lbs, cut into long strips", searchTerm: "pork shoulder" },
      { name: "honey", amount: "1/4 cup", searchTerm: "honey" },
      { name: "hoisin sauce", amount: "2 tbsp", searchTerm: "hoisin sauce" },
      { name: "soy sauce", amount: "2 tbsp", searchTerm: "soy sauce" },
      { name: "rice wine", amount: "1 tbsp", searchTerm: "rice wine" },
      { name: "red food coloring (optional)", amount: "1/2 tsp", searchTerm: "red food coloring" },
      { name: "garlic", amount: "2 cloves, minced", searchTerm: "garlic" }
    ],
    instructions: [
      "In a bowl, whisk together the honey, hoisin sauce, soy sauce, rice wine, red food coloring (if using), and minced garlic to create the marinade.",
      "Add the pork strips to the marinade, making sure they are fully coated. Cover and marinate in the refrigerator for at least 4 hours, or overnight.",
      "Preheat the oven to 375°F (190°C). Place the pork strips on a wire rack over a baking sheet lined with foil.",
      "Roast for 20-30 minutes, or until the pork is cooked through and has a slight char on the edges. Slice and serve hot."
    ],
    cookTime: 45,
    servings: 4,
    difficulty: "Medium"
  },
  {
      id: 101,
      name: "Slow Cooked Family Brisket",
      ingredients: [
        { name: "brisket", amount: "4 pounds", searchTerm: "brisket, beef brisket" },
        { name: "mustard", amount: "2 teaspoons", searchTerm: "mustard, dry mustard" },
        { name: "salt", amount: "1 teaspoon", searchTerm: "salt" },
        { name: "pepper", amount: "1/4 teaspoon - taste", searchTerm: "pepper" },
        { name: "paprika", amount: "2 teaspoons", searchTerm: "paprika" },
        { name: "garlic powder", amount: "1/2 - 1 teaspoon", searchTerm: "garlic powder" },
      ],
      instructions: [
        "Trim all excess fat from the brisket",
        "combine seasonings until well mixed; rub into all sides of brisket",
        "Place meat into greased 4-6 quart slow cooker, with fat side on top, cut to fit if needed",
        "Cover and cook on low for 10-12 hours, until fork tender",
        "Remove meat from slow cooker, let rest 15 minutes before slicing",
        "Cut against the grain into thin slices",
        "Serve with pan juices, if desired. Coleslaw, fresh veggies, and potato salad are great sides"

      ],
      cookTime: 660,
      servings: 5,
      difficulty: "Easy",
      category: "Dinner"
    },
    {
      id: 102,
      name: "Chocolate Chip Pancakes",
      ingredients: [
        { name: "flour", amount: "2 cups all-purpose", searchTerm: "flour" },
        { name: "milk", amount: "1 1/2 cups whole milk", searchTerm: "milk" },
        { name: "eggs", amount: "2 large eggs", searchTerm: "eggs" },
        { name: "sugar", amount: "2 tablespoons", searchTerm: "sugar" },
        { name: "baking powder", amount: "2 teaspoons", searchTerm: "baking powder" },
        { name: "baking soda", amount: "1 tsp", searchTerm: "baking soda" },
        { name: "butter", amount: "4 tablespoons melted", searchTerm: "butter" },
        { name: "salt", amount: "1/2 teaspoon", searchTerm: "salt" },
        { name: "nuts", amount: "1/2 teaspoon", searchTerm: "nuts" },
        { name: "chocolate chips", amount: "1/3 cup", searchTerm: "chocolate chips" },
        { name: "berries", amount: "1/4 cup", searchTerm: "berries" }
      ],
      instructions: [
        "Mix 2 cups flour, 2 tablespoons sugar, 2 teaspoons baking powder, and 1/2 teaspoon salt in a large bowl",
        "Whisk 1 1/2 cups milk, 2 eggs, and 4 tablespoons melted butter in another bowl",
        "Pour wet ingredients into dry ingredients and stir until just combined",
        "Don't overmix - lumps are okay",
        "Add 1-2 Tbsp butter to grease griddle or large pan at medium heat, wait until pan is warm",
        "Pour 1/4 cup batter per pancake onto hot griddle",
        "Add nuts, berries, chocolate chips, have fun with it",
        "Cook until bubbles form on surface, then flip",
        "Cook until golden brown on both sides",
        "Serve hot, with syrup and butter"
      ],
      cookTime: 20,
      servings: 4,
      difficulty: "Easy",
      category: "Breakfast"
    },
    {
      id: 103,
      name: "Ginger Chicken",
      ingredients: [
        { name: "boneless chicken thigh", amount: "1.1 pounds, or 500 grams", searchTerm: "chicken" },
        { name: "soy sauce", amount: "2 Tbsp Soy Sauce", searchTerm: "soy sauce" },
        { name: "ginger", amount: "2 Tsp ginger, minced", searchTerm: "ginger" },
        { name: "garlic", amount: "1 Tbsp or 3 cloves Garlic, minced", searchTerm: "garlic, minced garlic" },
        { name: "black pepper", amount: "1/2 Tsp ground black pepper", searchTerm: "pepper, black pepper" },
        { name: "Chinese Cooking Wine", amount: "1 Tbsp of Chinese Cooking Wine", searchTerm: "Chinese cooking wine" },
        { name: "Sesame Oil", amount: "1/2 Tbsp Sesame Oil", searchTerm: "sesame Oil" },
        { name: "cornstarch", amount: "3 Tbsp Cornstarch", searchTerm: "cornstarch" },
        { name: "water", amount: "1/4 Cup Water", searchTerm: "water" },
        { name: "ketchup", amount: "4 Tbsp Ketchup", searchTerm: "ketchup" },
        { name: "sriracha", amount: "Substitute Sriracha for ketchup for spicy version, 4 Tbsp sriracha", searchTerm: "sriracha" },
        { name: "honey", amount: "2 Tbsp Honey", searchTerm: "honey" },
        { name: "sesame seeds", amount: "optional, 2-4 Tbsp sesame seeds", searchTerm: "sesame seeds" }
      ],
      instructions: [
        "Clean and cut chicken into bite-sized pieces, about 1-1.5 inches.",
        "Marinate the chicken in the fridge preferably overnight but at least one hour.",
        "Let the chicken get to room temperature then dredge in cornstarch and into a medium preheated pan with about an inch of oil.",
        "Double fry chicken by cooking until light golden brown (about 2 minutes on each side) then drain and rest for 10 minutes.",
        "Raise the temperature to high and fry again for a minute or two, making sure both sides are golden brown and crispy.",
        "Remove chicken and let it drain, remove most of the oil leaving about 1-2 Tbsp.",
        "Lower the pan to low and add in ginger and garlic and saute for 30 seconds stirring continuously, raise to medium-low then add in the rest of the ingredients.",
        "Stir for another 90 seconds, if it's too thick add in more water a tablespoon at a time, or if it's too thin, let it reduce a little longer.",
        "Turn it up to high, add in the chicken, toss or stir until fully coated with sauce then serve!",
        "Optional - Garnish with sesame seeds if desired."
      ],
      cookTime: 20,
      servings: 4,
      difficulty: "Medium",
      category: "Dinner"
    },
];

const RecipeGenerator = ({ affiliateUtils }) => {
  const [availableIngredients, setAvailableIngredients] = useState([]);
  const [currentInput, setCurrentInput] = useState('');
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

 

const addIngredient = () => {
    if (currentInput.trim() && !availableIngredients.includes(currentInput.trim().toLowerCase())) {
      const newIngredient = currentInput.trim().toLowerCase();
      setAvailableIngredients([...availableIngredients, newIngredient]);
      setCurrentInput('');
      
      if (window.gtag) {
        window.gtag('event', 'ingredient_add', {
          'ingredient_name': newIngredient,
          'ingredients_total': availableIngredients.length + 1
        });
      }
    }
  };

  const removeIngredient = (ingredient) => {
    setAvailableIngredients(availableIngredients.filter(ing => ing !== ingredient));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      addIngredient();
    }
  };


 // Calculate matching recipes based on available ingredients
  const matchingRecipes = useMemo(() => {
    if (availableIngredients.length === 0) return [];

    // Helper function for flexible ingredient matching
    const ingredientMatches = (available, required) => {
      const availableLower = available.toLowerCase();
      const requiredLower = required.toLowerCase();
      
      // Check for exact match
      if (availableLower === requiredLower) return true;
      
      // Check if either contains the other (partial matching)
      if (availableLower.includes(requiredLower) || requiredLower.includes(availableLower)) return true;
      
      // Add more sophisticated matching for common variations
      const commonVariations = {
        'tomato': ['tomatoes', 'diced tomatoes', 'tomato puree', 'canned tomatoes'],
        'onion': ['onions', 'yellow onion', 'red onion', 'white onion'],
        'garlic': ['garlic cloves', 'minced garlic', 'garlic powder'],
        'chicken': ['chicken breast', 'chicken thighs', 'ground chicken', 'chicken strips'],
        'beef': ['ground beef', 'beef stew meat', 'beef strips', 'beef shoulder'],
        'cheese': ['cheddar cheese', 'mozzarella', 'parmesan cheese', 'shredded cheese']
      };
      
      // Check variations
      for (const [base, variations] of Object.entries(commonVariations)) {
        if (availableLower.includes(base) && variations.some(v => requiredLower.includes(v.toLowerCase()))) {
          return true;
        }
        if (requiredLower.includes(base) && variations.some(v => availableLower.includes(v.toLowerCase()))) {
          return true;
        }
      }
      
      return false;
    };

    return recipeDatabase
      .map(recipe => {
        // Skip invalid entries
        if (!recipe || !Array.isArray(recipe.ingredients)) {
          console.warn('Invalid recipe found:', recipe);
          return null;
        }

        const missingIngredients = [];
        const matchedIngredients = [];

        recipe.ingredients.forEach(ingredient => {
          // Handle both old and new data structures
          const searchTerm = ingredient.searchTerm || ingredient.name || 'unknown';
          
          // Check if we have a matching available ingredient
          const hasIngredient = availableIngredients.some(available => 
            ingredientMatches(available, searchTerm)
          );

          if (hasIngredient) {
            matchedIngredients.push(ingredient);
          } else {
            missingIngredients.push(ingredient);
          }
        });

        const totalIngredients = recipe.ingredients.length;
        const matchedCount = matchedIngredients.length;
        const matchPercentage = totalIngredients > 0 ? (matchedCount / totalIngredients) * 100 : 0;

        return {
          ...recipe,
          missingIngredients,
          matchedIngredients,
          matchPercentage,
          requiredIngredientsCount: totalIngredients,
          matchedCount
        };
      })
      .filter(recipe => recipe !== null && recipe.matchPercentage > 0)
      .sort((a, b) => {
        // Sort by match percentage first, then by fewer total ingredients needed
        if (b.matchPercentage !== a.matchPercentage) {
          return b.matchPercentage - a.matchPercentage;
        }
        return a.requiredIngredientsCount - b.requiredIngredientsCount;
      });
  }, [availableIngredients]);

  const getMatchColor = (percentage) => {
    if (percentage >= 80) return 'text-green-600 bg-green-100';
    if (percentage >= 60) return 'text-yellow-600 bg-yellow-100';
    return 'text-orange-600 bg-orange-100';
  };

  // Affiliate section renderer with buy links
const renderAffiliateSection = (recipe) => {
  if (!recipe || !affiliateUtils) return null;
  
  return (
    <div className={`mt-6 p-4 rounded-lg ${
      darkMode ? 'bg-gray-700 border border-gray-600' : 'bg-orange-50 border border-orange-200'
    }`}>
      <h4 className={`text-md font-semibold mb-3 ${
        darkMode ? 'text-white' : 'text-gray-800'
      }`}>
        🛒 Buy Missing Ingredients:
      </h4>
      
      {/* Display missing ingredients with buy links */}
      <div className="space-y-2 mb-4">
        {recipe.missingIngredients.map((ingredient, index) => (
          <div key={index} className={`flex items-center justify-between p-2 rounded ${
            darkMode ? 'bg-gray-600' : 'bg-white'
          }`}>
            <span className={darkMode ? 'text-gray-200' : 'text-gray-700'}>
              {ingredient.amount} {ingredient.name || ingredient.searchTerm}
            </span>
            <div className="flex gap-2">
              <a 
                href={affiliateUtils.generateAmazonLink(ingredient.searchTerm || ingredient.name)} 
                target="_blank" 
                rel="noopener noreferrer sponsored"
                onClick={() => affiliateUtils.trackAffiliateClick('amazon', ingredient.searchTerm, recipe.name)}
                className="px-3 py-1 bg-yellow-500 hover:bg-yellow-600 text-white text-xs rounded transition-colors"
              >
                Amazon
              </a>
              <a 
                href={affiliateUtils.generateInstacartLink(ingredient.searchTerm || ingredient.name)} 
                target="_blank" 
                rel="noopener noreferrer sponsored"
                onClick={() => affiliateUtils.trackAffiliateClick('instacart', ingredient.searchTerm, recipe.name)}
                className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white text-xs rounded transition-colors"
              >
                Instacart
              </a>
              <a 
                href={affiliateUtils.generateWalmartLink(ingredient.searchTerm || ingredient.name)} 
                target="_blank" 
                rel="noopener noreferrer sponsored"
                onClick={() => affiliateUtils.trackAffiliateClick('walmart', ingredient.searchTerm, recipe.name)}
                className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white text-xs rounded transition-colors"
              >
                Walmart
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Bulk buy options */}
      <div className={`pt-3 border-t ${darkMode ? 'border-gray-600' : 'border-orange-200'}`}>
        <p className={`text-sm mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          Or get all missing ingredients at once:
        </p>
        <div className="flex gap-2">
          <a 
            href={affiliateUtils.generateInstacartLink(recipe.missingIngredients.map(i => i.searchTerm || i.name))} 
            target="_blank" 
            rel="noopener noreferrer sponsored"
            onClick={() => affiliateUtils.trackAffiliateClick('instacart', 'bulk_order', recipe.name)}
            className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm rounded font-medium transition-colors text-center"
          >
            Shop All on Instacart
          </a>
          <a 
            href={affiliateUtils.generateWalmartLink()} 
            target="_blank" 
            rel="noopener noreferrer sponsored"
            onClick={() => affiliateUtils.trackAffiliateClick('walmart', 'bulk_order', recipe.name)}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded font-medium transition-colors text-center"
          >
            Shop All on Walmart
          </a>
        </div>
      </div>
    </div>
  );
};

  return (
    <div className={`min-h-screen transition-colors duration-300 p-4 ${
      darkMode 
        ? 'bg-[#000000]' 
        : 'bg-[#FFF6EE]' 
    }`}>
      <div className="max-w-6xl mx-auto">
        <header className="text-center mb-8">
          <div className="flex items-center justify-center mb-4 relative">
  <img 
    src={darkMode ? "/dark-800x300px.png" : "/light-800x300px.png"} 
    alt="Fridge to Fork Logo" 
    className="h-48 w-auto transition-all duration-300 ease-in-out"
  />
  <button
    onClick={() => setDarkMode(!darkMode)}
    className={`absolute right-0 p-2 rounded-full transition-colors ${
      darkMode 
        ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600' 
        : 'bg-white text-gray-600 hover:bg-gray-100'
    } shadow-lg`}
  >
    {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
  </button>
</div>
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Recipe Generator | Cook delicious meals with ingredients you already have!
          </p>
          
          <div className="mt-4">
            <Link 
              to="/" 
              className={`text-sm hover:underline ${
                darkMode ? 'text-orange-400 hover:text-orange-300' : 'text-orange-600 hover:text-orange-700'
              }`}
            >
              ← Back to Home
            </Link>
          </div>
        </header>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Ingredient Input Section */}
          <div className={`rounded-2xl shadow-lg p-6 ${
            darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white'
          }`}>
            <h2 className={`text-2xl font-semibold mb-4 flex items-center gap-2 ${
              darkMode ? 'text-white' : 'text-gray-800'
            }`}>
              <Search className={`w-6 h-6 ${darkMode ? 'text-orange-400' : 'text-orange-600'}`} />
              Available Ingredients
            </h2>
            
            <div className="flex gap-2 mb-4">
              <input
                type="text"
                value={currentInput}
                onChange={(e) => setCurrentInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter an ingredient (e.g., chicken, tomato, rice)"
                className={`flex-1 px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-colors ${
                  darkMode 
                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                    : 'border-gray-300 bg-white text-gray-900'
                }`}
              />
              <button
                onClick={addIngredient}
                className={`px-6 py-3 rounded-lg transition-colors flex items-center gap-2 ${
                  darkMode 
                    ? 'bg-orange-500 hover:bg-orange-600 text-white' 
                    : 'bg-orange-600 hover:bg-orange-700 text-white'
                }`}
              >
                <Plus className="w-4 h-4" />
                Add
              </button>
            </div>

            {availableIngredients.length > 0 && (
              <div className="mb-6">
                <h3 className={`font-medium mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Your Pantry ({availableIngredients.length} ingredients):
                </h3>
                <div className="flex flex-wrap gap-2">
                  {availableIngredients.map((ingredient, index) => (
                    <span
                      key={index}
                      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm ${
                        darkMode 
                          ? 'bg-orange-900 text-orange-200 border border-orange-700' 
                          : 'bg-orange-100 text-orange-800'
                      }`}
                    >
                      {ingredient}
                      <button
                        onClick={() => removeIngredient(ingredient)}
                        className={`transition-colors ${
                          darkMode ? 'hover:text-orange-100' : 'hover:text-orange-600'
                        }`}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {availableIngredients.length === 0 && (
              <div className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                <Sparkles className={`w-12 h-12 mx-auto mb-3 ${
                  darkMode ? 'text-gray-600' : 'text-gray-300'
                }`} />
                <p>Add ingredients to discover recipes you can make!</p>
              </div>
            )}
          </div>

          {/* Recipe Results Section */}
          <div className={`rounded-2xl shadow-lg p-6 ${
            darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white'
          }`}>
            <h2 className={`text-2xl font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-800'}`}>
              Recipe Suggestions ({matchingRecipes.length})
            </h2>

            {matchingRecipes.length > 0 ? (
              <div className="space-y-4 max-h-96 overflow-y-auto">
                {matchingRecipes.map((recipe) => (
                  <div
                    key={recipe.id}
                    className={`border rounded-lg p-4 cursor-pointer transition-all ${
                      darkMode 
                        ? 'border-gray-600 hover:bg-gray-700 hover:shadow-lg' 
                        : 'border-gray-200 hover:shadow-md'
                    }`}
                    onClick={() => setSelectedRecipe(recipe)}
                  >
                    <div className="flex justify-between items-start mb-2">
                      <h3 className={`text-lg font-medium ${
                        darkMode ? 'text-white' : 'text-gray-800'
                      }`}>
                        {recipe.name}
                      </h3>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        getMatchColor(recipe.matchPercentage)
                      }`}>
                        {Math.round(recipe.matchPercentage)}% match
                      </span>
                    </div>
                    
                    <div className={`flex items-center gap-4 text-sm mb-2 ${
                      darkMode ? 'text-gray-300' : 'text-gray-600'
                    }`}>
                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        {recipe.cookTime} min
                      </span>
                      <span className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        {recipe.servings} servings
                      </span>
                      <span className={`px-2 py-1 rounded text-xs ${
                        darkMode ? 'bg-gray-600 text-gray-300' : 'bg-gray-100 text-gray-700'
                      }`}>
                        {recipe.difficulty}
                      </span>
                    </div>

                    {recipe.missingIngredients.length > 0 && (
                      <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Missing: {recipe.missingIngredients.map(ing => ing.searchTerm).join(', ')}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            ) : availableIngredients.length > 0 ? (
              <div className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                <ChefHat className={`w-12 h-12 mx-auto mb-3 ${
                  darkMode ? 'text-gray-600' : 'text-gray-300'
                }`} />
                <p>No recipes found with your current ingredients.</p>
                <p className="text-sm">Try adding more common ingredients!</p>
              </div>
            ) : (
              <div className={`text-center py-8 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                <p>Add ingredients to see recipe suggestions</p>
              </div>
            )}
          </div>
        </div>

        {/* Recipe Detail Modal */}
        {selectedRecipe && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className={`rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto ${
              darkMode ? 'bg-gray-800' : 'bg-white'
            }`}>
              <div className={`sticky top-0 border-b p-6 ${
                darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
              }`}>
                <div className="flex justify-between items-start">
                  <div>
                    <h2 className={`text-2xl font-bold mb-2 ${
                      darkMode ? 'text-white' : 'text-gray-800'
                    }`}>
                      {selectedRecipe.name}
                    </h2>
                    <div className={`flex items-center gap-4 text-sm ${
                      darkMode ? 'text-gray-300' : 'text-gray-600'
                    }`}>
                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        {selectedRecipe.cookTime} minutes
                      </span>
                      <span className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        Serves {selectedRecipe.servings}
                      </span>
                      <span className={`px-2 py-1 rounded ${
                        darkMode ? 'bg-gray-600 text-gray-300' : 'bg-gray-100 text-gray-700'
                      }`}>
                        {selectedRecipe.difficulty}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setSelectedRecipe(null)}
                    className={`p-2 rounded-full transition-colors ${
                      darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'
                    }`}
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
              </div>

              <div className="p-6">
                <div className="mb-6">
                  <h3 className={`text-lg font-semibold mb-3 ${
                    darkMode ? 'text-white' : 'text-gray-800'
                  }`}>
                    Ingredients:
                  </h3>
                  <div className="grid grid-cols-2 gap-2 mb-4">
                    {selectedRecipe.ingredients.map((ingredient, index) => {
                      const hasIngredient = availableIngredients.some(available => 
                        available.includes(ingredient.searchTerm.toLowerCase()) || 
                        ingredient.searchTerm.toLowerCase().includes(available)
                      );
                      return (
                        <span
                          key={index}
                          className={`px-3 py-1 rounded-full text-sm ${
                            hasIngredient 
                              ? 'bg-green-100 text-green-800' 
                              : darkMode 
                                ? 'bg-red-900 text-red-200' 
                                : 'bg-red-100 text-red-800'
                          }`}
                        >
                          <strong>{ingredient.amount}</strong> {ingredient.name || ingredient.searchTerm}
                        </span>
                      );
                    })}
                  </div>

                  {renderAffiliateSection(selectedRecipe)}
                </div>

                <div>
                  <h3 className={`text-lg font-semibold mb-3 ${
                    darkMode ? 'text-white' : 'text-gray-800'
                  }`}>
                    Instructions:
                  </h3>
                  <ol className="space-y-2">
                    {selectedRecipe.instructions.map((step, index) => (
                      <li key={index} className="flex gap-3">
                        <span className={`flex-shrink-0 w-6 h-6 text-white text-sm font-medium rounded-full flex items-center justify-center ${
                          darkMode ? 'bg-orange-500' : 'bg-orange-600'
                        }`}>
                          {index + 1}
                        </span>
                        <span className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
                          {step}
                        </span>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeGenerator;